import "@DSG/Store/Pages/NearByBranchStateReducer";
import "@DSG/Store/Pages/AddToCartPopupStateReducer";
import "@DSG/Store/Pages/Header/ChangeBranch/ChangeBranchReducer";
import "@DSG/Store/Pages/OnePageCheckoutExt/OnePageCheckoutReducerExt";
import "@DSG/Store/Reducer/CoveoCommerceReducer";
import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
// import "@example/Store/Reducers";
// import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
// Importing nothing to trigger the side effects, which in this case adds custom reducers.
import colorPallete, {
    bodyFonts,
    buttonFonts,
    displayHeading,
    elevation,
    headlineFonts,
    labelFonts,
    printFonts,
    specialHeadings,
    themeFonts,
    themeFontWeights,
} from "@DSG/MobiusOverrides/styles/variables";
import { setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridOffset } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { StyledTypography } from "@insite/mobius/Link";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";


// For production, include a set of commonly used widgets in the main bundle
// the rest will be split into their own chunks
// Do not do this for the ./Overrides folder
const widgets = IS_PRODUCTION
    ? require.context("./Widgets", true, /(Header|Basic|Common|Footer|SignIn)\/.+?\.tsx$/)
    : require.context("./Widgets", true, /\.tsx$/);
// enable hot module reloading for widgets
const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id.toString(), () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const pages = require.context("./Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);
if (module.hot) {
    module.hot.accept(pages.id.toString(), () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
}

// Load all handlers so they are included in the bundle.
const handlers = require.context("./Handlers", true);
handlers.keys().forEach(key => handlers(key));

// in production, the widget extensions are included in the chunks created for widgets
// if (!IS_PRODUCTION) {
//     // load all widget extensions. They could be loaded individually instead
//     const widgetExtensions = require.context("./WidgetExtensions", true);
//     widgetExtensions.keys().forEach(key => widgetExtensions(key));
// }

// add some post styleguide customizations. These can't be overridden by the style guide
setPreStyleGuideTheme({
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl"],
        values: [0, 320, 768, 1024, 1024],
        maxWidths: [390, 768, 1024, 1024, 1440],
    },
    colors: {
        primary: {
            main: colorPallete.primaryRed500,
        },
        success: {
            main: colorPallete.semanticGreen500,
        },
        info: {
            main: colorPallete.semanticBlue500,
        },
        warning: {
            main: colorPallete.semanticRed500,
        },
        text: {
            main: "#1b1b1c",
        }
    },
    modal: {
        sizeVariants: {
            small: 500,
            medium: 600,
            large: 800,
        },
    },
    button: {
        primary: {
            shape: "pill",
            mergeCss: true,
            hoverStyle: {
                background: colorPallete.primaryMaroon500,
            },
            activeStyle: {
                background: colorPallete.grey800,
            },
            css: css`
                padding: 14px 32px;
                border: none;
                border-radius: 30px;
                &:disabled {
                    background: ${colorPallete.grey400};
                }
                @media screen and (max-width: 768px) {
                    padding: 10px 24px;
                }
            `,
            typographyProps: {
                color: colorPallete?.white,
                size: 16,
                weight: themeFontWeights.semiBold,
                lineHeight: "19.5px",
                css: css`
                    @media screen and (max-width: 768px) {
                        font-size: 14px;
                        line-height: 18.2px;
                    }
                `,
            },
        },
        secondary: {
            color: colorPallete.white,
            shape: "pill",
            mergeCss: true,
            css: css`
                padding: 14px 32px;
                border: 2px solid ${colorPallete.primaryRed500};
                border-radius: 30px;
                &:hover,
                &:active {
                    span {
                        color: ${colorPallete.white};
                    }
                }
                &:disabled {
                    border: 2px solid ${colorPallete.grey400};
                    background: ${colorPallete.white};
                    span {
                        color: ${colorPallete.grey400};
                    }
                }
                @media screen and (max-width: 768px) {
                    padding: 10px 24px;
                }
            `,
            typographyProps: {
                color: colorPallete.primaryRed500,
                size: 16,
                weight: themeFontWeights.semiBold,
                lineHeight: "19.5px",
                css: css`
                    @media screen and (max-width: 768px) {
                        font-size: 14px;
                        line-height: 21px;
                    }
                `,
            },
            hoverStyle: {
                background: colorPallete.primaryMaroon500,
                border: `2px solid ${colorPallete.primaryMaroon500}`,
                color: colorPallete.white,
            },
            activeStyle: {
                background: colorPallete.grey800,
                border: `2px solid ${colorPallete.grey800}`,
            },
        },
        tertiary: {
            color: colorPallete.white,
            shape: "pill",
            mergeCss: true,
            css: css`
                padding-left: 32px;
                padding-right: 32px;
                border: 2px solid ${colorPallete.primaryRed500};
                border-radius: 30px;
                &:hover,
                &:active {
                    span {
                        color: ${colorPallete.white};
                    }
                }
                &:disabled {
                    border: 2px solid ${colorPallete.grey400};
                    background: ${colorPallete.white};
                    span {
                        color: ${colorPallete.grey400};
                    }
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                padding-left: 24px;
                                padding-right: 24px;
                            `,
                        ],
                        "max",
                    )}
            `,
            typographyProps: {
                color: colorPallete.primaryRed500,
                size: 16,
                weight: themeFontWeights.semiBold,
                lineHeight: "19.5px",
                css: css`
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                font-size: ${buttonFonts.buttonSm.fontSize};
                                line-height: ${buttonFonts.buttonSm.lineHeight};
                            `,
                        ],
                        "max",
                    )}
                `,
            },
            hoverStyle: {
                background: colorPallete.primaryMaroon500,
                border: `2px solid ${colorPallete.primaryMaroon500}`,
                color: colorPallete.white,
            },
            activeStyle: {
                background: colorPallete.grey800,
                border: `2px solid ${colorPallete.grey800}`,
            },
        }
    },
    focus: {
        color: colorPallete.grey800, // no blue borders on link focus
    },
    shadows: {
        1: "box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.10);",
        2: "0px 4px 16px 0px rgba(0, 0, 0, 0.20);",
    },
    link: {
        defaultProps: {
            color: colorPallete.grey800,
        },
    },
    typography: {
        fontFamilyImportUrl: themeFonts.fontImportUrl,
        body: {
            fontFamily: themeFonts.fontFamilyPoppins,
            size: bodyFonts.body1RegularLg.fontSize,
            weight: bodyFonts.body1RegularLg.fontWeight,
        },
        p: {
            size: bodyFonts.body1RegularLg.fontSize,
            weight: bodyFonts.body1RegularLg.fontWeight,
        },
        h1: {
            color: colorPallete.grey800,
            size: headlineFonts.headline1SemiBoldLg.fontSize,
            lineHeight: headlineFonts.headline1SemiBoldLg.lineHeight,
            weight: headlineFonts.headline1SemiBoldLg.fontWeight,
            css: css`
                margin-bottom: 1rem;
                display: block;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    css`
                        font-size: ${headlineFonts.headline1SemiBoldSm.fontSize};
                        line-height: ${headlineFonts.headline1SemiBoldSm.lineHeight};
                    `,
                    null,
                    null,
                ], "max")}
            `
        },
        h2: {
            color: colorPallete.grey800,
            size: headlineFonts.headline2RegularLg.fontSize,
            lineHeight: headlineFonts.headline2RegularLg.lineHeight,
            weight: headlineFonts.headline2SemiBoldLg.fontWeight,
            css: css`
                margin-bottom: 1rem;
                display: block;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    css`
                        font-size: ${headlineFonts.headline2RegularSm.fontSize};
                        line-height: ${headlineFonts.headline2RegularSm.lineHeight};
                    `,
                    null,
                    null,
                ], "max")}
            `
        },
        h3: {
            color: colorPallete.grey800,
            size: headlineFonts.headline3RegularLg.fontSize,
            lineHeight: headlineFonts.headline3RegularLg.lineHeight,
            weight: headlineFonts.headline3SemiBoldLg.fontWeight,
            css: css`
                margin-bottom: 1rem;
                display: block;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    css`
                        font-size: ${headlineFonts.headline3RegularSm.fontSize};
                        line-height: ${headlineFonts.headline3RegularSm.lineHeight};
                    `,
                    null,
                    null,
                ], "max")}
            `
        },
        h4: {
            color: colorPallete.grey800,
            size: headlineFonts.headline4RegularLg.fontSize,
            lineHeight: headlineFonts.headline4RegularLg.lineHeight,
            weight: headlineFonts.headline4SemiBoldLg.fontWeight,
            css: css`
                margin-bottom: 1rem;
                display: block;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    css`
                        font-size: ${headlineFonts.headline4RegularSm.fontSize};
                        line-height: ${headlineFonts.headline4RegularSm.lineHeight};
                    `,
                    null,
                    null,
                ], "max")}
            `
        },
        h5: {
            color: colorPallete.grey800,
            size: headlineFonts.headline5RegularLg.fontSize,
            lineHeight: headlineFonts.headline5RegularLg.lineHeight,
            weight: headlineFonts.headline5SemiBoldLg.fontWeight,
            css: css`
                margin-bottom: 1rem;
                display: block;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    css`
                        font-size: ${headlineFonts.headline5RegularSm.fontSize};
                        line-height: ${headlineFonts.headline5RegularSm.lineHeight};
                    `,
                    null,
                    null,
                ], "max")}
            `
        },
        h6: {
            color: colorPallete.grey800,
            size: headlineFonts.headline6RegularLg.fontSize,
            lineHeight: headlineFonts.headline6RegularLg.lineHeight,
            weight: headlineFonts.headline6SemiBoldLg.fontWeight,
            css: css`
                margin-bottom: 1rem;
                display: block;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    css`
                        font-size: ${headlineFonts.headline6RegularSm.fontSize};
                        line-height: ${headlineFonts.headline6RegularSm.lineHeight};
                    `,
                    null,
                    null,
                ], "max")}
            `
        },
    },
    header: {
        isFullWidth: true,
    },
    footer: {
        isFullWidth: true,
        fullWidthColor: colorPallete.grey100,
    },
    checkbox: {
        defaultProps: {
            color: colorPallete.grey800,
            indeterminateColor: colorPallete.grey800,
            mergeCss: true,
            css: css`
                &.checkboxChecked {
                    width: 100%;
                }

                span[role="checkbox"] {
                    border: 1px solid ${colorPallete.grey800};
                    width: 24px;
                    height: 24px;
                    justify-content: center;
                    margin-top: 0 !important;
                    flex-shrink: 0;

                    + label {
                        margin-left: 8px;
                        font-size: ${bodyFonts.body2RegularLg.fontSize};
                        line-height: ${bodyFonts.body2RegularLg.lineHeight};
                        font-weight: normal;
                        flex-grow: 1;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        align-items: flex-start;

                        .facet-name {
                            padding-right: 5px;
                            word-break: break-word;
                        }

                        .facet-count {
                            color: ${colorPallete.grey600};
                            flex-shrink: 0;
                        }
                    }

                    svg {
                        width: 18px;
                        height: 18px;
                    }
                }
                span[role="checkbox"][aria-disabled="true"] {
                    background: ${colorPallete.grey200};
                }
            `,
        },
    },
    textField: {
        defaultProps: {
            mergeCss: true,
            cssOverrides: {
                formField: css`
                    [class*="FormFieldLabel-"] {
                        font-size: ${bodyFonts.body2SemiBoldLg.fontSize};
                        line-height: ${bodyFonts.body2SemiBoldLg.lineHeight};
                        min-height: 21px;

                        + [class*="FormInputWrapper"] {
                            margin-top: 4px;
                        }
                    }

                    input:not(.react-datetime-picker__inputGroup__input),
                    select:not(.react-datetime-picker__inputGroup__input),
                    textarea,
                    .mobiusFileUpload {
                        border: 1px solid ${colorPallete.grey500};
                        border-radius: 8px;
                        height: auto;
                        padding: 12px 16px;
                        font-size: ${bodyFonts.body2RegularLg.fontSize};
                        color: ${colorPallete.grey800};
                        &:focus,
                        &:focus-within {
                            border: 1px solid ${colorPallete.grey800};
                            border-radius: 8px;
                            height: auto;
                            padding: 12px 16px;
                            color: ${colorPallete.grey600};
                        }
                        &:focus {
                            border-width: 2px;
                        }

                        &:disabled {
                            background: ${colorPallete.grey200};
                            border: 1px solid ${colorPallete.grey200};
                            border-radius: 8px;
                            height: auto;
                            padding: 12px 16px;
                            color: ${colorPallete.grey600DisabledText};
                            -webkit-text-fill-color: ${colorPallete.grey600DisabledText}; 
                            -webkit-opacity: 1; 
                        }

                        &[aria-invalid="true"] {
                            border: 1px solid ${colorPallete.semanticError};
                            border-radius: 8px;
                            height: auto;
                            padding: 12px 16px;

                            &:focus {
                                border: 1px solid ${colorPallete.grey800};
                                border-radius: 8px;
                                height: auto;
                                padding: 12px 16px;
                                color: ${colorPallete.grey600};
                            }

                            &:focus {
                                border-width: 2px;
                            }

                            &[data-test-selector="signIn_password"] {
                                + [class*="FormFieldClickable-"] {
                                    top: 0;
                                    height: 56px;
                                    transform: initial;
                                    [class*="IconWrapper"] {
                                        height: 56px;
                                    }
                                }
                            }
                        }
                    }
                    .mobiusFileUpload {
                        min-height: 56px;
                        padding: 0 16px;

                        &:focus,
                        &:focus-within {
                            padding: 0 16px;
                        }
                    }
                    input:not(.react-datetime-picker__inputGroup__input) {
                        &[data-test-selector="signIn_password"] {
                            + [class*="FormFieldClickable-"] {
                                top: 50%;
                                transform: translate(0, -50%);
                            }
                        }
                    }
                    [class*="FormInputWrapper"] {
                        [class*="DescriptionWrapper-"] {
                            margin-top: 4px;
                            span {
                                font: ${bodyFonts.body2RegularLg.fontWeight} ${bodyFonts.body2RegularLg.fontSize} /
                                    ${bodyFonts.body2RegularLg.lineHeight} ${bodyFonts.body2RegularLg.fontFamily};
                                color: ${colorPallete.semanticError};
                            }
                        }
                    }
                `,
            },
        },
    },
    pagination: {
        defaultProps: {
            buttonProps: {
                color: colorPallete.grey800,
                css: css`
                    border-radius: 4px;
                    margin: 0 4px;
                    width: 40px;
                    height: 40px;
                    background: ${colorPallete.white};
                    border: 1px solid ${colorPallete.grey300};

                    span {
                        color: ${colorPallete.grey800};
                    }
                    &,
                    &[aria-current="page"] {
                        padding: 1px !important;
                    }
                    &:not(:disabled):hover {
                        color: ${colorPallete.white};
                        background: ${colorPallete.primaryRed500};
                        border-color: ${colorPallete.primaryRed500};
                        span {
                            color: ${colorPallete.white};
                        }
                    }
                    &[aria-current="page"],
                    &[data-test-selector*="pageNumber"] {
                        min-width: 40px;
                        max-width: 48px;
                        min-height: 40px;
                        width: auto;
                    }
                    &[data-test-selector="pagination_previousButton"],
                    &[data-test-selector="pagination_nextButton"] {
                        min-height: 40px;
                        &:not(:disabled):hover {
                            border: none;
                        }
                    }

                    &[data-test-selector="pagination_previousButton"] {
                        padding: 1px 16px 1px 8px !important;
                    }
                    &[data-test-selector="pagination_nextButton"] {
                        padding: 1px 8px 1px 16px !important;
                        flex-direction: row-reverse;
                    }
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    &[data-test-selector="pagination_previousButton"],
                                    &[data-test-selector="pagination_nextButton"] {
                                        padding: 1px !important;
                                    }
                                `,
                                null,
                            ],
                            "max",
                        )}
                `,
            },
            cssOverrides: {
                currentButton: css`
                    border: 2px solid ${colorPallete.grey800};
                    background: ${colorPallete.white};
                    color: ${colorPallete.grey800};
                    padding: 1px !important;
                    span {
                        color: ${colorPallete.grey800};
                    }
                `,
            },
        },
    },
    radio: {
        defaultProps: {
            mergeCss: true,
            css: css`
                input {
                    & + label {
                        &::before {
                            border: 2px solid ${colorPallete.grey800};
                            width: 24px;
                            height: 24px;
                        }
                    }
                    &:checked {
                        + label::after {
                            width: 12px;
                            height: 12px;
                            left: 6px;
                            top: calc(50% - 5.5px);
                            background: ${colorPallete.black};
                        }
                        &:not(:disabled) {
                            & + label::before {
                                background: ${colorPallete.white};
                                border-color: unset;
                            }
                        }
                    }
                    &:focus {
                        + label::before {
                            box-shadow: none;
                        }
                    }
                    &:disabled {
                        + label::before {
                            background: ${colorPallete.white};
                            border: 2px solid ${colorPallete.grey300} !important;
                        }
                    }
                }
            `,
        },
    },
    
    breadcrumbs: {
        defaultProps: {
            css: css`
                [aria-current="page"] {
                }
            `,
            typographyProps: {
                fontFamily: labelFonts.label1Regular.fontFamily,
                size: labelFonts.label1Regular.fontSize,
                weight: labelFonts.label1Regular.fontWeight,
                lineHeight: labelFonts.label1Regular.lineHeight,
                css: css`
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    font-size: ${bodyFonts.body2RegularLg.fontSize};
                                    line-height: ${bodyFonts.body2RegularLg.lineHeight};
                                `,
                            ],
                            "min",
                        )}
                `,
            },
        },
    },
    globalStyle: {
        css: css`
            /*
                Global Changes
            */
           
           
            :focus {
                outline: 2px solid ${colorPallete.grey800};
            }
            span[role="checkbox"]:focus + label,
            [type="radio"]:focus + label {
                outline: 2px solid ${colorPallete.grey800};
                outline-offset: 1px;
            }
              
            /* Remove focus outline for mouse interactions */
            span[role="checkbox"]:not(:focus-visible) + label,
            [type="radio"]:not(:focus-visible) + label,
            :focus:not(:focus-visible) {
                outline: none !important;  
                outline-offset: 0 !important; 
            }
              
            body {
                .justifyCenter {
                    justify-content: center;
                }
                .textCenter {
                    text-align: center;
                }
                .margin0 {
                    margin: 0;
                }
                .marginB20 {
                    margin-bottom: 20px;
                }
                .marginT20 {
                    margin-top: 20px;
                }
                .marginB24 {
                    margin-bottom: 24px;
                }
                .marginT24 {
                    margin-top: 24px;
                }
                .gap-24 {
                    gap: 24px;
                    flex-wrap: wrap;
                    display: flex;
                }
                > footer[class*="PageStyle"] {
                    display: none;
                }
                .marginTB24 {
                    margin-top: 24px !important; 
                    margin-bottom: 24px !important;
                }
                .width1280 {
                    &,
                    &[class*="GridItem"] {
                        max-width: 1280px;
                        margin: 0 auto;
                    }
                }
                .headingDisplay {
                    font-size: ${displayHeading.displaySemiboldLg.fontSize};
                    line-height: ${displayHeading.displaySemiboldLg.lineHeight};
                }
                .heading1 {
                    font-size: ${headlineFonts.headline1SemiBoldLg.fontSize};
                    line-height: ${headlineFonts.headline1SemiBoldLg.lineHeight};
                }
                .heading2 {
                    font-size: ${headlineFonts.headline2SemiBoldLg.fontSize};
                    line-height: ${headlineFonts.headline2SemiBoldLg.lineHeight};
                }
                .heading3 {
                    font-size: ${headlineFonts.headline3SemiBoldLg.fontSize};
                    line-height: ${headlineFonts.headline3SemiBoldLg.lineHeight};
                }
                .heading4 {
                    font-size: ${headlineFonts.headline4SemiBoldLg.fontSize};
                    line-height: ${headlineFonts.headline4SemiBoldLg.lineHeight};
                }
                .heading5 {
                    font-size: ${headlineFonts.headline5SemiBoldLg.fontSize};
                    line-height: ${headlineFonts.headline5SemiBoldLg.lineHeight};
                }
                .heading6 {
                    font-size: ${headlineFonts.headline6SemiBoldLg.fontSize};
                    line-height: ${headlineFonts.headline6SemiBoldLg.lineHeight};
                }
                .dsgWhiteBtn {
                    min-height: 38px;
                    padding: 7px 22px;
                    border-radius: 30px;
                    background: ${colorPallete.white};
                    font: ${buttonFonts.buttonSm.fontWeight} ${buttonFonts.buttonSm.fontSize}/${buttonFonts.buttonSm.lineHeight} ${buttonFonts.buttonSm.fontFamily};
                }
                .dsgWhiteBtnPrimary {
                    border: 2px solid ${colorPallete.primaryRed500};
                    &,
                    [class*="TypographyStyle"],
                    [class*="TypographyStyle"]:hover {
                        color: ${colorPallete.primaryRed500};
                    }
                }
                .dsgWhiteBtnSecondary {
                    border: 2px solid ${colorPallete.grey800};
                    &,
                    [class*="TypographyStyle"],
                    [class*="TypographyStyle"]:hover {
                        color: ${colorPallete.grey800};
                    }
                }
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            .headingDisplay {
                                font-size: ${displayHeading.displaySemiboldSm.fontSize};
                                line-height: ${displayHeading.displaySemiboldSm.lineHeight};
                            }
                            .heading1 {
                                font-size: ${headlineFonts.headline1SemiBoldSm.fontSize};
                                line-height: ${headlineFonts.headline1SemiBoldSm.lineHeight};
                            }
                            .heading2 {
                                font-size: ${headlineFonts.headline2SemiBoldSm.fontSize};
                                line-height: ${headlineFonts.headline2SemiBoldSm.lineHeight};
                            }
                            .heading3 {
                                font-size: ${headlineFonts.headline3SemiBoldSm.fontSize};
                                line-height: ${headlineFonts.headline3SemiBoldSm.lineHeight};
                            }
                            .heading4 {
                                font-size: ${headlineFonts.headline4SemiBoldSm.fontSize};
                                line-height: ${headlineFonts.headline4SemiBoldSm.lineHeight};
                            }
                            .heading5 {
                                font-size: ${headlineFonts.headline5SemiBoldSm.fontSize};
                                line-height: ${headlineFonts.headline5SemiBoldSm.lineHeight};
                            }
                            .heading6 {
                                font-size: ${headlineFonts.headline6SemiBoldSm.fontSize};
                                line-height: ${headlineFonts.headline6SemiBoldSm.lineHeight};
                            }
                        `,
                    ],
                    "max",
                )}
            }
            .desktopSpecific {
                display: none !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        .mobileSpecific {
                            display: none !important;
                        }
                        .desktopSpecific {
                            display: block !important;
                        }
                        .marginDeskTopBottom48 {
                            margin-top: 48px !important;
                            margin-bottom: 48px !important;
                        }
                    `,
                ],
                "min",
            )}
            .importErrorLogViewWrapper {
                [data-test-selector="pageBreadcrumbs"] {
                    padding-left: 0;
                    padding-right: 0;
                }
            }
            main {
                .staticCmsPage {
                    max-width: 1280px;
                }
                [data-test-selector="orderUpload_includeHeading"] {
                    display: flex;
                }
            }
     
            .staticCmsPage {
                .contentCenter {
                    text-align: center;
                }
                p {
                    color: ${colorPallete.grey800};
                }
                h1 {
                    font: ${headlineFonts.headline2SemiBoldSm.fontWeight} ${headlineFonts.headline2SemiBoldSm.fontSize} /
                        ${headlineFonts.headline2SemiBoldSm.lineHeight} ${headlineFonts.headline2SemiBoldSm.fontFamily};
                    margin-bottom: 24px;
                    color: ${colorPallete.grey800};
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    font-size: ${headlineFonts.headline2SemiBoldLg.fontSize};
                                    line-height: ${headlineFonts.headline2SemiBoldLg.lineHeight};
                                    margin-bottom: 40px;
                                `,
                            ],
                            "min",
                        )}
                }
                .note {
                    font: ${bodyFonts.body2RegularSm.fontWeight} ${bodyFonts.body2RegularSm.fontSize} /
                        ${bodyFonts.body2RegularSm.lineHeight} ${bodyFonts.body2RegularSm.fontFamily};
                }
                .dsgConfirmCheckmark {
                    height: 68px;
                    margin-bottom: 8px;
                }
                .dsgConfirmCheckmark img {
                    height: 68px;
                }
                .dsgPrimaryBtn {
                    &:hover {
                        [class*="TypographyStyle"] {
                            color: ${colorPallete.white};
                        }
                    }
                }
                .primaryLink,
                .secondaryLink {
                    text-decoration: underline;
                }
            }
            .filterSection {
                border-radius: 8px;
                border: 1px solid ${colorPallete.grey500};
                background: ${colorPallete.grey50};
                padding: 16px;
                &[class*="GridWrapper-"] {
                    margin-bottom: 24px;
                }
            }
            main {
                .radioBoxGroupContainer {
                    legend {
                        &,
                        &[class*="TypographyStyle"] {
                            margin-bottom: 8px;
                        }
                    }
                    > span[class*="TypographyStyle"] {
                        font: ${labelFonts.label1Regular.fontWeight} ${labelFonts.label1Regular.fontSize} /
                                ${labelFonts.label1Regular.lineHeight} ${labelFonts.label1Regular.fontFamily};
                        color: ${colorPallete.semanticRed500};
                        padding-top: 4px;
                    }
                }
            }
            .radioBoxGroupContainer {
                column-gap: 14px;
                flex-direction: row !important;
                flex-wrap: wrap;
                color: ${colorPallete.grey800};
                > span {
                    width: 100%;
                }
                input[type="radio"] {
                    width: 0;
                } 
                legend {
                    font: ${bodyFonts.body2SemiBoldSm.fontWeight} ${bodyFonts.body2SemiBoldSm.fontSize} /
                        ${bodyFonts.body2SemiBoldSm.lineHeight} ${bodyFonts.body2SemiBoldSm.fontFamily};
                    width: 100%;
                    color: ${colorPallete.grey800};
                }
                [class*="RadioStyle"] {
                    display: flex;
                    input {
                        appearance: none;
                        margin: 0;
                        & + label {
                            row-gap: 8px;
                            border: 1px solid ${colorPallete.grey600};
                            padding: 16px 8px;
                            min-height: 112px;
                            border-radius: 8px;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            cursor: pointer;
                            width: 155px;
                            margin: 0;
                            font: ${bodyFonts.body2RegularSm.fontWeight} ${bodyFonts.body2RegularSm.fontSize} /
                                ${bodyFonts.body2RegularSm.lineHeight} ${bodyFonts.body2RegularSm.fontFamily};
                            &:before,
                            &:after {
                                display: none;
                            }
                            svg {
                                width: 40px;
                                height: 40px;
                            }
                        }
                        &:focus + label {
                            border-width: 2px;
                        }
                        &:checked {
                            & + label {
                                &:before,
                                &:after {
                                    display: none;
                                }
                            }
                        }
                        &:disabled {
                            & + label {
                                background: ${colorPallete.grey200};
                                color: ${colorPallete.greyDisabled600};
                                border-color: ${colorPallete.grey200};
                            }
                        }
                    }
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    input {
                                        & + label {
                                            width: 178px;
                                        }
                                    }
                                `,
                            ],
                            "min",
                        )}
                }
                .radioBoxStyledContainer {
                    position: relative;
                    width: 155px;
                    color: ${colorPallete.grey800};
                    > .checkIcon {
                        display: none;
                        position: absolute;
                        right: 8px;
                        top: 8px;
                    }
                    [class*="RadioStyle"] {
                        &:not(.activeRadio):hover {
                            input {
                                & + label {
                                    border-color: ${colorPallete.grey600};
                                    box-shadow: ${elevation.dp04};
                                }
                            }
                        }
                        &:not(.activeRadio):hover,
                        &.activeRadio {
                            & + .checkIcon {
                                display: block;
                            }
                        }
                        &.activeRadio {
                            input {
                                & + label {
                                    border: 2px solid ${colorPallete.grey800};
                                    box-shadow: ${elevation.dp04};
                                }
                            }
                        }
                    }
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    width: 178px;
                                `,
                            ],
                            "min",
                        )}
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                column-gap: 24px;
                            `,
                        ],
                        "min",
                    )}
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                width: 100%;
                                display: flex;
                                .radioBoxStyledContainer {
                                    max-width: 178px;
                                    width: calc(50% - 8px);
                                    display: flex;
                                    margin: 0;
                                }
                                > span[class*="TypographyStyle"] {
                                    &:empty {
                                        margin: 0;
                                    }
                                }
                                [class*="RadioStyle"] {
                                    width: 100%;
                                    input + label {
                                        max-width: 178px;
                                        width: 100%;
                                        text-align: center;
                                    }
                                }
                            `,
                        ],
                        "max",
                    )}
            }
            .d-none {
                display: none;
            }

            .d-block {
                display: block;
            }
            .pickTimeVariesInventoryText {
                color: ${colorPallete.semanticError};
                font: ${labelFonts.label2Regular.fontWeight} ${labelFonts.label2Regular.fontSize}/${labelFonts.label2Regular.lineHeight} ${labelFonts.label2Regular.fontFamily};
                display: flex;
                width: 100%;
                flex-wrap: wrap;
                svg {
                    width: 16px;
                    height: 16px;
                    min-width: 16px;
                    margin-right: 4px;
                }
                > span {
                    width: calc(100% - 20px);
                }
            }
            .backorderInventoryText,
            .discontinuedInventoryText {
                border-radius: 8px;
                border: 1px solid ${colorPallete.grey300};
                display: flex;
                padding: 3px 4px;
                justify-content: center;
                align-items: center;
                gap: 8px;
                min-width: 204px;
                flex-wrap: wrap;
                color: ${colorPallete.semanticOrange800};
                font: ${labelFonts.label3SemiBold.fontWeight} ${labelFonts.label3SemiBold.fontSize}/17px ${labelFonts.label3SemiBold.fontFamily};
                svg {
                    width: 16px;
                    height: 16px;
                    min-width: 16px;
                    color: ${colorPallete.semanticColorOrange500};
                }
                > span {
                    width: calc(100% - 20px);
                }
            }
            .discontinuedInventoryAvailableNotReplenished {
                color: ${colorPallete.semanticError};
                font: ${labelFonts.label2Regular.fontWeight} ${labelFonts.label2Regular.fontSize}/${labelFonts.label2Regular.lineHeight} ${labelFonts.label2Regular.fontFamily};
                display: flex;
                width: 100%;
                max-width: 328px;
                flex-wrap: wrap;
                svg {
                    width: 16px;
                    height: 16px;
                    min-width: 16px;
                    margin-right: 4px;
                }
                > span {
                    width: calc(100% - 20px);
                }
                a {
                    &, &:hover, &:focus, &:active {
                        [class*="StyledTypography"] {
                            color: ${colorPallete.semanticError}; 
                            text-decoration: underline;
                        }
                    }
                }
                .d-inline {
                    display: initial;
                    top: -1px;
                    position: relative;
                }
            }
            .changeDeliverOrderLink {
                button {
                    padding-left: 20px;
                    [class*="TypographyStyle"] {
                        color: ${colorPallete.semanticError};
                        font: ${labelFonts.label2Regular.fontWeight} ${labelFonts.label2Regular.fontSize}/${labelFonts.label2Regular.lineHeight} ${labelFonts.label2Regular.fontFamily};
                        text-decoration: underline;
                    }
                }
            }
            .inStockCartInventoryText {
                color: ${colorPallete.grey800};
                font: ${labelFonts.label3SemiBold.fontWeight} ${labelFonts.label3SemiBold.fontSize}/${labelFonts.label3SemiBold.lineHeight} ${labelFonts.label3SemiBold.fontFamily};
                flex-wrap: wrap;
                &.successText {
                    color: ${colorPallete.semanticGreen500};
                }
                svg {
                    width: 16px;
                    height: 16px;
                    min-width: 16px;
                    margin-right: 4px;
                }
                > span {
                    width: calc(100% - 20px);
                }
            }
            
            .backorderInventoryCartText {
                color: ${colorPallete.semanticError};
                width: 100%;
                font: ${labelFonts.label3SemiBold.fontWeight} ${labelFonts.label3SemiBold.fontSize}/${labelFonts.label3SemiBold.lineHeight} ${labelFonts.label3SemiBold.fontFamily};
                margin-top: 12px;
                margin-bottom: 0;
                display: flex;
            }
            .grayInventoryText,
            .restrictedInventoryText,
            .discontinuedCartInventoryText {
                color: ${colorPallete.grey800};
                font: ${labelFonts.label3SemiBold.fontWeight} ${labelFonts.label3SemiBold.fontSize}/${labelFonts.label3SemiBold.lineHeight} ${labelFonts.label3SemiBold.fontFamily};
                flex-wrap: wrap;
                svg {
                    width: 16px;
                    height: 16px;
                    min-width: 16px;
                    margin-right: 4px;
                }
                > span {
                    width: calc(100% - 20px);
                }
            }
            .pickTimeVariesCartInventoryText {
                color: ${colorPallete.semanticError};
                width: 100%;
                font: ${labelFonts.label3SemiBold.fontWeight} ${labelFonts.label3SemiBold.fontSize}/${labelFonts.label3SemiBold.lineHeight} ${labelFonts.label3SemiBold.fontFamily};
                margin-top: 12px;
                margin-bottom: 0;
                display: flex;
                svg {
                    width: 16px;
                    height: 16px;
                    min-width: 16px;
                    margin-right: 4px;
                }
                > span {
                    width: calc(100% - 20px);
                }
            }
            .react-calendar__navigation {
                button {
                    &:focus {
                        outline: 2px solid ${colorPallete.grey800};
                        offset-width: 1px;
                    }
                    &:focus:not(:focus-visible) {
                        outline: none;
                        offset-width: 0;
                    }
                }
            }
            .date-range-picker * {
                border-radius: 8px !important;
            }
            .react-datetime-picker {
                border-radius: 0 !important;
                &:not(:disabled),
                &,
                &:focus-within {
                    border-radius: 8px !important;
                }

                &:focus {
                   // border-radius: 8px;
                    border: 2px solid ${colorPallete.grey800};
                    .react-datetime-picker__wrapper {
                        padding: 8px 16px;
                    }
                }
                .react-datetime-picker__wrapper {
                    padding: 10px 16px;
                  //  border-radius: 8px;
                    .react-datetime-picker__calendar-button {
                        order: -1;
                        width: 32px;
                        padding: 0 !important;
                        margin-top: 2px;
                        text-align: left;

                        [class*="DatePickerIcon-"] {
                            width: 24px;
                            height: 24px;
                            padding: 0;
                        }
                        &:focus {
                            span {
                                outline: none;
                            }
                        }
                    }

                    input:not(.react-datetime-picker__inputGroup__input),
                    select:not(.react-datetime-picker__inputGroup__input),
                    textarea {
                        border: none;
                        padding: 0;
                    }
                }
                &:not(:disabled),
                &:focus-within {
                    .react-datetime-picker__inputGroup {
                        padding-left: 0 !important;
                    }
                }
            }

            .react-calendar__navigation {
                .react-calendar__navigation__next-button {
                    min-width: 24px;
                    width: 24px;
                    height: 24px;
                    padding: 0;
                }
            }
            .react-calendar__viewContainer {
                button {
                    &:focus{
                        background: ${colorPallete.grey800} !important;
                        color: ${colorPallete.white} !important;
                    }
                    &:focus:not(:visible) {
                        background: inherit;
                        color: inherit;
                    }
                }
            }
            .recommendation-carousel {
                max-width: 1280px;
                > [class*="GridOffset-"] {
                    margin: 0;
                    width: 100%;
                }
                > div > div {
                    padding: 0;
                    > div {
                        padding: 8px 0;
                        &:not(:empty) {
                            padding: 48px 40px;
                        }
                    }
                }
             
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            > div > div {
                                > div:not(:empty) {
                                    padding: 16px 0;
                                }
                            }
                        `
                    ],
                    "max",
                )}
            }
            [data-test-selector="page_DsgCustomPage"] main {
                overflow: visible;
            }
            main {
                padding-bottom: 48px !important;

                .activePopover:not(.dynamicDropdownCustom) {
                    [class*="IconWrapper"] {
                        transform: rotate(-180deg);
                    }
                }
                .disabledLabel {
                    width: 100%;
                    label {
                        color: ${colorPallete.grey600DisabledText};
                    }
                    [class*="FormFieldStyle"] {
                        [class*="FormInputWrapper"] {
                            .dynamicDropdownCustom {
                                border-color: ${colorPallete.grey200};
                                background: ${colorPallete.grey200};
                                border-radius: 8px;
                            }
                        }
                    }
                }
                .errorOnFormField[class*="FormFieldStyle"] {
                    label {
                        color: ${colorPallete.semanticError};
                    }
                    [class*="FormInputWrapper"] {
                        .dynamicDropdownCustom {
                            border-color: ${colorPallete.semanticError};
                            input:not(.react-datetime-picker__inputGroup__input):not(:disabled) {
                                border-radius: 8px;
                            }
                        }
                    }
                }
                .disabledFormField {
                    label {
                        color: ${colorPallete.grey600DisabledText};
                    }
                    [class*="FormFieldStyle"] {
                        [class*="FormInputWrapper"] {
                            .dynamicDropdownCustom {
                                border-color: ${colorPallete.grey200};
                            }
                        }
                    }
                    .errorOnFormField[class*="FormFieldStyle"] {
                        [class*="FormInputWrapper"] {
                            .dynamicDropdownCustom {
                                border-color: ${colorPallete.semanticRed500};
                            }
                        }
                    }
                }
                [class*="FormFieldStyle"] {
                    [class*="FormInputWrapper"] {
                        .activePopover[role="combobox"] {
                            input,
                            select {
                                &:not(.react-datetime-picker__inputGroup__input) {
                                    border-color: ${colorPallete.grey800};
                                }
                            }
                        }
                        .dynamicDropdownCustom {
                            [class*="IconWrapper"] {
                                width: 24px;
                                height: 100%;
                                top: 0;
                                padding: 0;
                                right: 16px;
                                border-radius: 0;
                                display: flex;
                            }
                            input,
                            select {
                                &:not(.react-datetime-picker__inputGroup__input) {
                                    &,
                                    &:hover,
                                    &:focus,
                                    &:active {
                                        line-height: 22px;
                                        padding: 15px 16px;
                                        min-height: 56px;
                                    }
                                  
                                    &:disabled {
                                        background: ${colorPallete.grey200};
                                        border-color: ${colorPallete.grey200};
                                        &,
                                        &::placeholder,
                                        & + span + span + span {
                                            color: ${colorPallete.greyDisabled600};
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                padding-top: 24px !important;
                                padding-bottom: 40px !important;
                            `,
                            null,
                        ],
                        "max",
                    )}

                .primaryLink {
                    &,
                    span[class*="TypographyStyle"] {
                        color: ${colorPallete.primaryRed500};
                    }
                    &:hover {
                        &,
                        span[class*="TypographyStyle"] {
                            color: ${colorPallete.primaryMaroon500};
                        }
                    }
                    &:active {
                        &,
                        span[class*="TypographyStyle"] {
                            color: ${colorPallete.grey800};
                        }
                    }
                }
                .secondaryLink {
                    &,
                    span[class*="TypographyStyle"] {
                        color: ${colorPallete.grey800};
                    }
                    &:hover {
                        &,
                        span[class*="TypographyStyle"] {
                            color: ${colorPallete.primaryMaroon500};
                        }
                    }
                    &:active {
                        &,
                        span[class*="TypographyStyle"] {
                            color: ${colorPallete.grey800};
                        }
                    }
                }
            }
            .dsgBtn {
                min-height: 38px;
                padding: 9px 24px;
                border-radius: 30px;
                font: ${buttonFonts.buttonSm.fontWeight} ${buttonFonts.buttonSm.fontSize} /
                    ${buttonFonts.buttonSm.lineHeight} ${buttonFonts.buttonSm.fontFamily};
                text-align: center;
                justify-content: center;
                [class*="TypographyStyle"] {
                    color: ${colorPallete.white};
                }
                &:active {
                    background: ${colorPallete.grey800};
                    border-color: ${colorPallete.grey800};
                }
            }
            .dsgCMSBtn {
                min-height: 38px;
                padding: 4px 24px;
                border-radius: 30px;
                font: ${buttonFonts.buttonSm.fontWeight} ${buttonFonts.buttonSm.fontSize} /
                    ${buttonFonts.buttonSm.lineHeight} ${buttonFonts.buttonSm.fontFamily};
                text-align: center;
                display: inline-flex;
                align-items: center;
                gap: 8px;
                justify-content: center;
                > span {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                }
                [class*="LazyImageStyle"] {
                    padding: 0 !important;
                }
                &,
                &:hover,
                &:focus {
                    [class*="TypographyStyle"] {
                        color: inherit;
                    }
                }
                &.dsgPrimaryRed {
                    background: ${colorPallete.primaryRed500};
                    color: ${colorPallete.white};
                    border: 1px solid ${colorPallete.primaryRed500}; 
                }
                &.dsgPrimaryBlack {
                    background: ${colorPallete.grey800};
                    color: ${colorPallete.white};
                    border: 1px solid ${colorPallete.grey800}; 
                }
                &.dsgSecondaryRed {
                    background: ${colorPallete.white};
                    color: ${colorPallete.primaryRed500};
                    border: 2px solid ${colorPallete.primaryRed500}; 
                }
                &.dsgSecondaryBlack {
                    background: ${colorPallete.white};
                    color: ${colorPallete.grey800};
                    border: 2px solid ${colorPallete.grey800}; 
                }
            }
            .dsgSecondaryBtn,
            .dsgSecondaryDarkBtn {
                padding: 6px 24px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            .dsgBtn {
                                min-height: 48px;
                                border-radius: 30px;
                                font-size: ${buttonFonts.buttonLg.fontSize};
                                line-height: ${buttonFonts.buttonLg.lineHeight};
                            }
                            .dsgCMSBtn {
                                min-height: 48px;
                                border-radius: 30px;
                                font-size: ${buttonFonts.buttonLg.fontSize};
                                line-height: ${buttonFonts.buttonLg.lineHeight};
                            }
                            .showInMobile {
                                display: none !important;
                            }
                            .filterSection {
                                padding: 24px;
                            }
                        `,
                        css`
                            .dsgBtn {
                                padding: 14px 32px;
                            }
                            .dsgSecondaryBtn,
                            .dsgSecondaryDarkBtn {
                                padding: 12px 32px;
                            }
                        `,
                    ],
                    "min",
                )}
            .dsgPrimaryBtn {
                background: ${colorPallete.primaryRed500};
                border-color: ${colorPallete.primaryRed500};
                &:hover {
                    background: ${colorPallete.primaryMaroon500};
                    border-color: ${colorPallete.primaryMaroon500};
                    [class*="TypographyStyle"] {
                        color: ${colorPallete.white};
                    }
                }
                &:focus {
                    background: ${colorPallete.grey800};
                    border-color: ${colorPallete.grey800};
                    outline-offset: 1px;
                    [class*="TypographyStyle"] {
                        color: ${colorPallete.white};
                    }
                }
                &:focus:not(:focus-visible) {
                    outline-offset: 0;
                }

                &:disabled {
                    background: ${colorPallete.grey400};
                    border-color: ${colorPallete.grey400};
                }
                &.openNewWindowIcon {
                    &:after {
                        content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='24' viewBox='0 0 25 24' fill='none'%3E%3Cg%3E%3Cpath d='M19.5 19H5.5V5H12.5V3H5.5C4.39 3 3.5 3.9 3.5 5V19C3.5 20.1 4.39 21 5.5 21H19.5C20.6 21 21.5 20.1 21.5 19V12H19.5V19ZM14.5 3V5H18.09L8.26 14.83L9.67 16.24L19.5 6.41V10H21.5V3H14.5Z' fill='%23FFFFFF'/%3E%3C/g%3E%3C/svg%3E");
                    }
                }
            }
            .dsgSecondaryBtn {
                background: ${colorPallete.white};
                border: 2px solid ${colorPallete.primaryRed500};
                [class*="TypographyStyle"] {
                    color: ${colorPallete.primaryRed500};
                }
                &:hover {
                    background: ${colorPallete.primaryMaroon500};
                    border-color: ${colorPallete.primaryMaroon500};
                    [class*="TypographyStyle"] {
                        color: ${colorPallete.white};
                    }
                }
                &:focus {
                    background: ${colorPallete.grey800};
                    border-color: ${colorPallete.grey800};
                    [class*="TypographyStyle"] {
                        color: ${colorPallete.white};
                    }
                }
                &:hover,
                &:active {
                    [class*="TypographyStyle"] {
                        color: ${colorPallete.white};
                    }
                }
                &:disabled {
                    border-color: ${colorPallete.grey400};
                    color: ${colorPallete.grey400};
                }
                &.openNewWindowIcon {
                    &:after {
                        content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='24' viewBox='0 0 25 24' fill='none'%3E%3Cg%3E%3Cpath d='M19.5 19H5.5V5H12.5V3H5.5C4.39 3 3.5 3.9 3.5 5V19C3.5 20.1 4.39 21 5.5 21H19.5C20.6 21 21.5 20.1 21.5 19V12H19.5V19ZM14.5 3V5H18.09L8.26 14.83L9.67 16.24L19.5 6.41V10H21.5V3H14.5Z' fill='%23C91E24'/%3E%3C/g%3E%3C/svg%3E");
                    }
                    &:hover,
                    &:focus {
                        &:after {
                            content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='24' viewBox='0 0 25 24' fill='none'%3E%3Cg%3E%3Cpath d='M19.5 19H5.5V5H12.5V3H5.5C4.39 3 3.5 3.9 3.5 5V19C3.5 20.1 4.39 21 5.5 21H19.5C20.6 21 21.5 20.1 21.5 19V12H19.5V19ZM14.5 3V5H18.09L8.26 14.83L9.67 16.24L19.5 6.41V10H21.5V3H14.5Z' fill='%23FFFFFF'/%3E%3C/g%3E%3C/svg%3E");
                        }
                    }
                }
            }
            .dsgPrimaryDarkBtn {
                background: ${colorPallete.grey800};
                border-color: ${colorPallete.grey800};
                &:hover {
                    background: ${colorPallete.grey700};
                    border-color: ${colorPallete.grey700};
                }
                &:disabled {
                    background: ${colorPallete.grey400};
                    border-color: ${colorPallete.grey400};
                }
                &:active {
                    background: ${colorPallete.grey900};
                    border-color: ${colorPallete.grey900};
                }
            }
            .dsgSecondaryDarkBtn {
                background: ${colorPallete.white};
                border: 2px solid ${colorPallete.grey800};
                [class*="TypographyStyle"] {
                    color: ${colorPallete.grey800};
                }
                &:hover {
                    background: ${colorPallete.grey700};
                    border-color: ${colorPallete.grey700};
                }
                &:hover,
                &:active {
                    [class*="TypographyStyle"] {
                        color: ${colorPallete.white};
                    }
                }
                &:active {
                    background: ${colorPallete.grey900};
                    border-color: ${colorPallete.grey900};
                }
                &:disabled {
                    border-color: ${colorPallete.grey400};
                    color: ${colorPallete.grey400};
                }
            }
            .downloadBtn {
                padding-top: 2px;
                padding-bottom: 2px;
                .imageOnHover {
                    display: none
                }
                .imageDefault,
                .imageOnHover {
                    min-width: 24px;
                }
                [class*="LazyImageStyle"] {
                    padding: 0 !important;
                }
                .imageDefault {
                    display: inline-flex;
                }
                > [class*="TypographyStyle"] {
                    display: flex;
                    align-items: center;
                    column-gap: 4px;
                    line-height: initial;
                }
                &:hover,
                &:focus {
                    .imageOnHover {
                        display: inline-flex;
                    }
                    .imageDefault {
                        display: none;
                    }
                }
            }
            [data-test-selector="page_OnePageCheckoutPage"] {
                #pageHeader {
                    #header_shipToButton-popover {
                        max-height: calc(100vh);
                        right: 0;
                    }
                }
            }
            #react-app > div:not([data-test-selector="page_OnePageCheckoutPage"]) {
                .findLocationModal { 
                    #header_shipToButton-popover {
                        max-height: 78vh;
                    }
                    [class*="GridItemStyle"] {
                        > span {
                            margin-left: 0;
                        }
                    }
                }
            }
            @media screen and (min-width: 1024px){
                .findLocationModal { 
                    #header_shipToButton-popover {
                        width: 390px;
                        right: 0;
                    }
                }
            }
            .recommendation-carousel {
                > div > [class*="GridItem"] {
                    > [class*="Wrapper"],
                    [class*="ZoneWrapper-"] {
                        column-gap: 24px;
                        display: flex;
                        row-gap: 16px;
                        flex-direction: column;
                        @media screen and (min-width: 1024px) and (max-width: 1200px) {
                            [data-test-selector="carousel_slide"] {
                                padding: 0 10px;
                            }
                        }
                      
                        ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    & {
                                        flex-wrap: nowrap;
                                        flex-direction: row;
                                        align-items: flex-start;
                                        > div {
                                            width: calc(50% - 12px);
                                            &[data-widget*="Common/ProductCarousel"] {
                                                &:empty {
                                                    display: none;
                                                }
                                                &:not(:empty) + [data-widget="Common/ProductCarousel"]:not(:empty) {
                                                    width: 50%;
                                                    min-width: 50px;
                                                }
                                                &:not(:empty) {
                                                    flex: 1;
                                                    width: 50%;
                                                    min-width: 50px;
                                                }
                                                &:empty {
                                                    flex: 1;
                                                    width: 100%;
                                                }
                                            }
                                            &:first-child:last-child{
                                                width: 100%;
                                                .wrapper {
                                                    justify-content: center;
                                                }
                                                .lessItemsThanSlideToScroll {
                                                    transform: initial !important;
                                                    justify-content: center;
                                                }
                                            }
                                        }
                                    }
                                `,
                            ],
                            "min",
                        )}
                        @media screen and (min-width: 1200px) {
                            column-gap: 80px;
                            > div {
                                width: calc(50% - 40px);
                                &:first-child:last-child{
                                    width: 100%;
                                }
                            }
                        }
                    }
                }
                
            }
            .summaryMsgForDelivery {
                display: flex;
                column-gap: 8px;
                padding-top: 32px;
                margin-bottom: -16px !important;
                .summaryMsgIconWrapper {
                    min-width: 24px;
                    max-height: 24px;
                }
                .summaryMsgTextWrapper {
                    min-height: 24px;
                    align-items: center;
                    display: flex;
                    flex-wrap: wrap;
                    &,
                    p {
                        font: ${labelFonts.label1Regular.fontWeight} ${labelFonts.label1Regular.fontSize} /
                            ${labelFonts.label1Regular.lineHeight} ${labelFonts.label1Regular.fontFamily};
                        color: ${colorPallete.grey800};
                    }
                    strong {
                        font-weight: 600;
                    }
                    p {
                        margin-bottom: 0;
                    }
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    &,
                                    p {
                                        font-size: ${bodyFonts.body2RegularLg.fontSize};
                                        line-height: ${bodyFonts.body2RegularLg.lineHeight};
                                    }
                                `,
                            ],
                            "min",
                        )}
                }
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            margin: 0 0 8px !important;
                            padding: 0 !important;
                        `,
                    ],
                    "max",
                )}
            }

            .boxGreyAll24 {
                border-radius: 8px;
                padding: 24px;
                background: ${colorPallete.grey50};
                border: 1px solid ${colorPallete.grey300};
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            .showInDesktop {
                                display: none !important;
                            }
                        `,
                    ],
                    "max",
                )}
            [data-test-selector="textBadges"]:not(:empty) {
                &,
                > div {
                    display: flex;
                    align-items: flex-start;
                    flex-wrap: wrap;
                    margin: 0;
                    column-gap: 8px;
                }
                > div {
                    [class*="TextBadge"] {
                        border-radius: 4px;
                        display: inline-flex;
                        word-wrap: break-word;
                        display: inline-flex;
                        line-height: 12px;
                        min-height: 24px;
                        align-items: center;
                        max-width: 68px;
                        padding: 0 2px;
                        min-width: 56px;
                        * {
                            font: italic ${themeFontWeights.semiBold} 10px/12px ${themeFonts.fontFamilyPoppins};
                        }
                    }
                }
            }
            
            [class*="TextBadge"] {
                cursor: pointer;
                padding: 8px;
                border-radius: 4px;
                font-style: italic;
                font-size: 10px;
                line-height: 10px;
            }
            .tooltipBadgeImageWrapper {
                position: relative;
                display: flex;

                .tooltipBadgeImageText {
                    display: none;
                    position: absolute;
                    text-align: center;
                    left: 0;
                    min-width: 60px;
                    max-width: 225px;
                    width: 225px;
                    top: 100%;
                    margin-top: 1px;
                    z-index: 9;
                    padding: 16px;
                    text-align: left;
                    border-radius: 4px;
                    font: ${labelFonts.label2Regular.fontWeight} ${labelFonts.label2Regular.fontSize} /
                        ${labelFonts.label2Regular.lineHeight} ${labelFonts.label2Regular.fontFamily};
                    color: ${colorPallete.white};
                    box-shadow: ${elevation.dp08};
                    background: ${colorPallete.grey700};
                    strong {
                        font: ${labelFonts.label2Regular.fontWeight} ${labelFonts.label2Regular.fontSize} /
                            ${labelFonts.label2Regular.lineHeight} ${labelFonts.label2Regular.fontFamily};
                    }
                }
                svg {
                    width: 16px;
                    height: 16px;
                }
                .close-button {
                    height: 16px;
                }
                &:hover {
                    [class*="LazyImageStyle"],
                    [class*="TextBadge"] {
                        & + .tooltipBadgeImageText {
                            display: flex;
                            column-gap: 8px;
                            justify-content: space-between;
                        }
                    }
                }
            }
            .tooltipBadgeWrapper {
                position: relative;
                display: flex;

                .tooltipBadgeText {
                    display: none;
                    position: absolute;
                    text-align: center;
                    left: 0;
                    min-width: 60px;
                    max-width: 200px;
                    top: 100%;
                    margin-top: 1px;
                    z-index: 9;
                    padding: 16px;
                    border-radius: 4px;
                    font: ${labelFonts.label2Regular.fontWeight} ${labelFonts.label2Regular.fontSize} /
                        ${labelFonts.label2Regular.lineHeight} ${labelFonts.label2Regular.fontFamily};
                    color: ${colorPallete.white};
                    box-shadow: ${elevation.dp08};
                    background: ${colorPallete.grey700};
                    white-space: nowrap;
                    .close-button {
                        cursor: pointer;
                    }
                }
                svg {
                    width: 16px;
                    height: 16px;
                }
                .close-button {
                    height: 16px;
                }
                &:hover {
                    [class*="LazyImageStyle"],
                    [class*="TextBadge"] {
                        & + .tooltipBadgeText {
                            display: flex;
                            column-gap: 8px;
                            justify-content: space-between;
                        }
                    }
                }
            }

            @media screen and (min-width: 769px) {
                .email-grid-item button {
                    padding-left: 20px;
                    padding-right: 20px;
                    min-width: 125px;
                }
            }
            [data-test-selector="productCompareRemoveAllButton"] {
                padding: 11px 32px;
            }
            [data-test-selector="cookiePolicy_ClosePolicy"] {
                [class*="IconWrapper"] {
                    color: ${colorPallete.primaryRed500};
                }
            }
            @media screen and (max-width: 767px) {
                [data-test-selector="productCompareDrawer"] {
                    [class*="GridOffset"] {
                        [class*="GridItemStyle"] {
                            max-width: 100%;
                            flex-basis: 100%;
                        }
                    }
                }

                [data-test-selector="modal_ModalContent"] {
                    [class*="ModalContent"] {
                        button {
                            padding: 10px 18px !important;
                        }
                    }
                }

                [data-test-selector="cookiePolicy_ClosePolicy"] {
                    padding: 4px 0;
                }
                [data-test-selector="cookiePolicy_AcceptCookies"],
                [data-test-selector="cookiePolicy_ClosePolicy"],
                [data-test-selector="productCompareOpenComparePageButton"],
                [data-test-selector="productCompareRemoveAllButton"] {
                    min-height: 38px;
                }
                [data-test-selector="productCompareRemoveAllButton"] {
                    padding: 6px 32px;
                }
            }

            body,
            html {
                scroll-behavior: smooth;
            }
            @media print {
                [class*="PageLayoutWrapper"] > span {
                    display: none;
                }
                .drawer [aria-labelledby="drawerTitle"] {
                    box-shadow: none;
                }
            }
            .link-btn {
                padding: 7px 32px;
                border: none;
                border-radius: 30px;
                font-size: ${buttonFonts.buttonLg.fontSize};
                line-height: 20px;
                font-weight: ${buttonFonts.buttonLg.fontWeight};
                justify-content: center;
                &:focus {
                    outline-offset: 1px;
                }
                svg {
                    margin-right: 4px;
                    min-width: 28px;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                font-size: ${buttonFonts.buttonSm.fontSize};
                            `,
                        ],
                        "max",
                    )}
            }

            .primary-link-btn {
                color: ${colorPallete.white};
                background: ${colorPallete.primaryRed500};
                span[class*="StyledTypography-"] {
                    color: ${colorPallete.white};
                    align-items: center;
                    display: flex;
                }
                &:hover {
                    background: ${colorPallete.primaryMaroon500};
                    span[class*="StyledTypography-"] {
                        color: ${colorPallete.white};
                    }
                }
                &:active {
                    background: ${colorPallete.grey800};
                }
                &:disabled {
                    background: ${colorPallete.grey400};
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                padding: 14px 32px;
                                &[data-test-selector="productPrice_PricingMessageSignIn"] {
                                    padding: 14px 6px;
                                }
                            `,
                        ],
                        "min",
                    )}
            }
            .secondary-link-btn {
                color: ${colorPallete.primaryRed500};
                border: 2px solid ${colorPallete.primaryRed500};
                background: ${colorPallete.white};
                span[class*="StyledTypography-"] {
                    color: ${colorPallete.primaryRed500};
                    align-items: center;
                    display: flex;
                }
                &:hover {
                    background: ${colorPallete.primaryMaroon500};
                    border: 2px solid ${colorPallete.primaryMaroon500};
                    span[class*="StyledTypography-"] {
                        color: ${colorPallete.white};
                    }
                }
                &:active {
                    background: ${colorPallete.grey800};
                    border: 2px solid ${colorPallete.grey800};
                }
                &:hover,
                &:active {
                    color: ${colorPallete.white};
                    span {
                        color: ${colorPallete.white};
                    }
                }
                &:disabled {
                    border: 2px solid ${colorPallete.grey400};
                    background: ${colorPallete.white};
                    span {
                        color: ${colorPallete.grey400};
                    }
                }
            }
            @media screen and (max-width: 768px) {
                .hide-on-mobile {
                    display: none !important;
                }
            }

            @media screen and (max-width: 769px) {
                .mobile-logo {
                    display: none !important;
                }
            }

            @media screen and (min-width: 769px) and (max-width: 1023px) {
                .logo-on-tablet {
                    display: none !important;
                }
            }

            @media screen and (min-width: 1023px) {
                .desktop-logo {
                    display: none !important;
                }
            }

            @media screen and (min-width: 768px) and (max-width: 1023px) {
                .hide-on-tablet {
                    display: none !important;
                }
            }
            @media screen and (min-width: 1023px) {
                .hide-on-desktop {
                    display: none !important;
                }
            }
            [data-id="checkbox"] {
                align-items: flex-start !important;
            }

            .hide {
                display: none !important;
            }

            .btn {
                padding: 14px 32px;
                border: none;
                border-radius: 30px;
                font-size: ${buttonFonts.buttonLg.fontSize};
                line-height: ${buttonFonts.buttonLg.lineHeight};
                font-weight: ${buttonFonts.buttonLg.fontWeight};

                &.no-icon {
                    svg {
                        display: none;
                    }
                    &:hover {
                        span {
                            color: ${colorPallete.white}!important;
                        }
                    }
                }

                @media only screen and (max-width: 768px) {
                    padding: 10px 24px;
                    font-size: ${buttonFonts.buttonSm.fontSize};
                    line-height: ${buttonFonts.buttonSm.lineHeight};
                    font-weight: ${buttonFonts.buttonSm.fontWeight};
                }

                &-primary {
                    color: ${colorPallete.white};
                    background: ${colorPallete.primaryRed500};

                    span[class*="StyledTypography-"] {
                        color: ${colorPallete.white};
                    }

                    &:hover {
                        background: ${colorPallete.primaryMaroon500};
                        span[class*="StyledTypography-"] {
                            color: ${colorPallete.white};
                        }
                    }
                    &:active {
                        background: ${colorPallete.grey800};
                    }
                    &:disabled {
                        background: ${colorPallete.grey400};
                    }
                }

                &-secondary {
                    color: ${colorPallete.primaryRed500};
                    border: 2px solid ${colorPallete.primaryRed500};
                    background: ${colorPallete.white};
                    padding: 12px 32px;
                    
                    > span {
                        color: ${colorPallete.primaryRed500};
                    }
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    padding: 7px 32px;
                                    font-size: 14px;
                                `,
                            ],
                            "max",
                        )}
                    &:hover {
                        background: ${colorPallete.primaryMaroon500};
                        border: 2px solid ${colorPallete.primaryMaroon500};
                    }

                    &:active {
                        background: ${colorPallete.grey800};
                        border: 2px solid ${colorPallete.grey800};
                    }

                    &:hover,
                    &:active {
                        color: ${colorPallete.white};
                        span {
                            color: ${colorPallete.white};
                        }
                    }
                    &:disabled {
                        border: 2px solid ${colorPallete.grey400};
                        background: ${colorPallete.white};
                        span {
                            color: ${colorPallete.grey400}!important;
                        }
                        &:hover {
                            span {
                                color: ${colorPallete.grey400}!important;
                            }
                        }
                    }

                    &.icon-left {
                        &:hover {
                            &::before {
                                content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3E%3Cpath d='M10 13L5 8L10 3' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") !important;
                            }
                        }
                        &::before {
                            content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3E%3Cpath d='M10 13L5 8L10 3' stroke='%23C91E24' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") !important;
                        }
                    }

                    &.icon-right {
                        &:hover {
                            &::after {
                                content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3E%3Cpath d='M6 3L11 8L6 13' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") !important;
                            }
                        }
                        &::after {
                            content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'%3E%3Cpath d='M6 3.5L11 8.5L6 13.5' stroke='%23C91E24' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") !important;
                        }
                    }
                }

                &.icon-left {
                    position: relative;
                    padding-left: 52px;

                    @media only screen and (max-width: 768px) {
                        padding-left: 44px;
                    }

                    &::before {
                        content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3E%3Cpath d='M10 13L5 8L10 3' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
                        position: absolute;
                        margin-right: 4px;
                        width: 16px;
                        height: 16px;
                        top: 50%;
                        transform: translate(0, -50%);
                        right: calc(100% - 52px);
                        @media only screen and (max-width: 768px) {
                            right: calc(100% - 44px);
                        }
                    }
                }

                &.icon-right {
                    position: relative;
                    padding-right: 52px;

                    @media only screen and (max-width: 768px) {
                        padding-right: 44px;
                    }

                    &::after {
                        content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3E%3Cpath d='M6 3L11 8L6 13' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
                        position: absolute;
                        margin-left: 4px;
                        top: 50%;
                        transform: translate(0, -50%);
                        width: 16px;
                        height: 16px;
                        left: calc(100% - 52px);
                        @media only screen and (max-width: 768px) {
                            left: calc(100% - 44px);
                        }
                    }
                }
            }

            .btn-primary-dark {
                background: ${colorPallete.grey800};
                &:hover {
                    background: ${colorPallete.grey700};
                }
                &:active {
                    background: ${colorPallete.grey900};
                }
                &:disabled {
                    background: ${colorPallete.grey400};
                }
            }

            .btn-secondary-dark {
                background: ${colorPallete.white};
                border: 2px solid ${colorPallete.grey800};
                &:hover {
                    background: ${colorPallete.grey700};
                    border: 2px solid ${colorPallete.grey700};

                    [class*="StyledTypography"] {
                        color: ${colorPallete.white};
                    }
                }
                &:active {
                    background: ${colorPallete.grey900};
                    border: none;
                }
                &:disabled {
                    background: ${colorPallete.white};
                    border: 2px solid ${colorPallete.grey400};
                }
            }

            .text-link {
                font-family: ${themeFonts.fontFamilyPoppins};
                font-size: ${buttonFonts.buttonLg.fontSize};
                font-weight: ${buttonFonts.buttonLg.fontWeight};
                line-height: ${buttonFonts.buttonLg.lineHeight};

                &.text-link-sm {
                    font-size: ${buttonFonts.buttonSm.fontSize};
                    line-height: ${buttonFonts.buttonSm.lineHeight};
                }

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                font-size: ${buttonFonts.buttonSm.fontSize};
                                font-weight: ${buttonFonts.buttonSm.fontWeight};
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )}

                &-primary,
                &-primary span[class*="StyledTypography-"] {
                    color: ${colorPallete.primaryRed500};
                }

                &-secondary,
                &-secondary span[class*="StyledTypography-"] {
                    color: ${colorPallete.grey800};
                }

                &-active {
                    text-decoration: underline;
                }

                &-primary,
                &-secondary {
                    &:hover {
                        color: ${colorPallete.primaryMaroon500};
                        [class*="StyledTypography-"],
                        [class*="IconWrapper"] {
                            color: ${colorPallete.primaryMaroon500};
                        }
                    }
                    &:active {
                        color: ${colorPallete.grey800};
                        [class*="StyledTypography-"],
                        [class*="IconWrapper"] {
                            color: ${colorPallete.grey800};
                        }
                    }
                    &:disabled {
                        color: ${colorPallete.grey400};
                        [class*="StyledTypography-"],
                        [class*="IconWrapper"] {
                            color: ${colorPallete.grey400};
                        }
                    }
                }

                &-primary {
                    &.icon-right {
                        &::after {
                            content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'%3E%3Cpath d='M6 3.5L11 8.5L6 13.5' stroke='%23C91E24' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
                            width: 16px;
                            height: 16px;
                            margin-left: 4px;
                        }
                        &:hover {
                            &::after {
                                content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'%3E%3Cpath d='M6 3.5L11 8.5L6 13.5' stroke='%239E0406' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
                            }
                        }
                        &:active {
                            &::after {
                                content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'%3E%3Cpath d='M6 3.5L11 8.5L6 13.5' stroke='%231B1C1C' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
                            }
                        }
                        &:disabled {
                            &::after {
                                content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'%3E%3Cpath d='M6 3.5L11 8.5L6 13.5' stroke='%23D0D0D0' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
                            }
                        }
                    }
                    &.icon-left {
                        &::before {
                            content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'%3E%3Cpath d='M10 13.5L5 8.5L10 3.5' stroke='%23C91E24' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
                            width: 16px;
                            height: 16px;
                            margin-right: 4px;
                        }
                        &:hover {
                            &::before {
                                content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'%3E%3Cpath d='M10 13.5L5 8.5L10 3.5' stroke='%239E0406' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
                            }
                        }
                        &:active {
                            &::before {
                                content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'%3E%3Cpath d='M10 13.5L5 8.5L10 3.5' stroke='%231B1C1C' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
                            }
                        }
                        &:disabled {
                            &::before {
                                content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'%3E%3Cpath d='M10 13.5L5 8.5L10 3.5' stroke='%23D0D0D0' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
                            }
                        }
                    }
                }
                &-secondary {
                    &.icon-right {
                        &::after {
                            content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'%3E%3Cpath d='M6 3.5L11 8.5L6 13.5' stroke='%231B1C1C' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
                            width: 16px;
                            height: 16px;
                            margin-left: 4px;
                        }
                        &:hover {
                            &::after {
                                content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'%3E%3Cpath d='M6 3.5L11 8.5L6 13.5' stroke='%239E0406' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
                            }
                        }
                        &:active {
                            &::after {
                                content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'%3E%3Cpath d='M6 3.5L11 8.5L6 13.5' stroke='%231B1C1C' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
                            }
                        }
                        &:disabled {
                            &::after {
                                content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'%3E%3Cpath d='M6 3.5L11 8.5L6 13.5' stroke='%23D0D0D0' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
                            }
                        }
                    }
                    &.icon-left {
                        &::before {
                            content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'%3E%3Cpath d='M10 13.5L5 8.5L10 3.5' stroke='%231B1C1C' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
                            width: 16px;
                            height: 16px;
                            margin-right: 4px;
                        }
                        &:hover {
                            &::before {
                                content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'%3E%3Cpath d='M10 13.5L5 8.5L10 3.5' stroke='%239E0406' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
                            }
                        }
                        &:active {
                            &::before {
                                content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'%3E%3Cpath d='M10 13.5L5 8.5L10 3.5' stroke='%231B1C1C' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
                            }
                        }
                        &:disabled {
                            &::before {
                                content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'%3E%3Cpath d='M10 13.5L5 8.5L10 3.5' stroke='%23D0D0D0' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
                            }
                        }
                    }
                }
            }

            /* RTE Components Styles */
            /* Homepage Hero Banner */
            .hero-banner {
                min-height: 370px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        css`
                            max-height: unset;
                        `,
                        null,
                        null,
                    ], "max")}

                margin-bottom: 48px !important;
                @media only screen and (max-width: 768px) {
                    padding-top: 0;
                    margin-bottom: 48px;
                }
                > div[class*="GridOffset-"] {
                    @media only screen and (min-width: 1024px) {
                        gap: 8px;
                    }
                    @media only screen and (max-width: 1024px) {
                        flex-direction: column;

                        .hero-banner-columns {
                            flex-basis: 100%;
                            max-width: 100%;

                            &:last-child {
                                padding: 16px 16px 0 16px;
                            }

                            &:only-child {
                                padding: 0;
                            }
                        }
                    }
                }
                [class*="Wrapper-"] {
                    height: 100%;
                }

                [class*="ContentWrapper-"] {
                    border-radius: 8px;
                }

                &-columns {
                    &:last-child {
                        @media only screen and (min-width: 1024px) {
                            flex-basis: 32.33%;
                            max-width: 32.33%;
                        }
                        [class*="Wrapper-"] {
                            display: flex;
                            flex-direction: column;
                            row-gap: 8px;

                            @media only screen and (max-width: 768px) {
                                row-gap: 16px;
                                justify-content: flex-end;
                            }

                            > div {
                                flex-basis: calc(50% - 4px);
                                min-height: calc(50% - 4px);
                            }
                        }
                    }
                    &:only-child {
                        @media only screen and (min-width: 1024px) {
                            flex-basis: 100%;
                            max-width: 100%;
                        }

                        [class*="Wrapper-"] {
                            row-gap: 0;
                            @media only screen and (max-width: 768px) {
                                row-gap: 0;
                            }
                            > div {
                                flex-basis: 100% !important;
                            }
                        }
                    }

                    @media only screen and (max-width: 768px) {
                        [class*="ContentWrapper-"]:not(.header-content) {
                            padding: 24px;
                        }
                    }
                }

                .static-banner-wrapper {
                    display: flex;
                    align-items: flex-start;
                    gap: 24px;
                    justify-content: space-between;
                    .banner-content {
                        .image-icon {
                            display: flex;
                        }
                        
                        color: ${colorPallete.white};
                        a, a span {
                            color: ${colorPallete.white};
                        }
                        h3 {
                            font-size: ${headlineFonts.headline3SemiBoldLg.fontSize};
                            line-height: ${headlineFonts.headline3SemiBoldLg.lineHeight};
                            font-weight: ${headlineFonts.headline3SemiBoldLg.fontWeight};
                            color: ${colorPallete.white};
                            @media only screen and (max-width: 768px) {
                                font-size: ${headlineFonts.headline2SemiBoldSm.fontSize};
                                line-height: ${headlineFonts.headline2SemiBoldSm.lineHeight};
                            }
                        }
                        p {
                            font-size: ${bodyFonts.body2RegularLg.fontSize};
                            line-height: ${bodyFonts.body2RegularLg.lineHeight};
                            font-weight: ${bodyFonts.body2RegularLg.fontWeight};
                            margin-bottom: 0;
                            @media only screen and (max-width: 768px) {
                                font-size: ${bodyFonts.body2RegularSm.fontSize};
                                line-height: ${bodyFonts.body2RegularSm.lineHeight};
                            }
                        }
                    }
                    .banner-icon {
                        flex-shrink: 0;
                    }
                }
            }

            [data-test-selector="page_Page"],
                [data-test-selector="homePage"] [data-id="tabContent"] {
                [data-test-selector="productImage"] {
                    display: block;
                    max-width: 138px;
                    max-height: 138px;
                    margin: 0 auto;
                    padding: 0;
                    [class*="StyledImg"] {
                        max-width: 138px;
                        max-height: 138px !important;
                        min-height: 138px;
                        object-fit: contain;
                    }
                }
            }
            [data-test-selector="homePage"] {
                .product-carousel {
                    h4 {
                        margin-bottom: 16px !important;
                    }
                }
                [data-id="tabContent"] [data-test-selector="productImage"] {
                    display: block;
                    max-width: 138px;
                    max-height: 138px;
                    margin: 0 auto;
                    padding: 0;
                    [class*="StyledImg"] {
                        max-width: 138px;
                        max-height: 138px !important;
                        min-height: 138px;
                        object-fit: contain;
                    }
                }

                [class*="TypographyStyle"] {
                    &:empty {
                        display: none;
                    }
                }
            }
           
            /* Industry served section */
            .industry-served-section {
                > [class*="GridOffset-"] {
                    margin-bottom: 48px;
                    margin-top: 48px;

                    @media only screen and (max-width: 768px) {
                        margin: 48px 0;
                    }
                }
            }
            .industry-served-row {
                &[class*="GridWrapper-"] {
                    &:first-child {
                        margin-top: 40px;
                    }

                    &:not(:last-child) {
                        margin-bottom: 56px;
                    }

                    [class^="Wrapper-"] {
                        display: grid;
                        gap: 16px;
                        justify-content: center;

                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    css`
                                        padding: 0 16px;
                                        grid-template-columns: repeat(1, 243px);
                                        grid-row-gap: 40px;
                                    `,

                                    css`
                                        grid-template-columns: repeat(2, 173px);
                                        grid-row-gap: 40px;
                                    `,

                                    css`
                                        grid-template-columns: repeat(3, 243px);
                                        grid-row-gap: 56px;
                                    `,

                                    css`
                                        grid-template-columns: repeat(4, 243px);
                                        grid-row-gap: 56px;
                                    `,
                                ],
                                "min",
                            )}

                        @media screen and (max-width: 767px) {
                            grid-template-columns: repeat(2, 173px);
                        }

                        @media screen and (min-width: 768px) and (max-width: 1024px) {
                            grid-template-columns: repeat(3, 243px);
                        }
                    }
                }

                [class*="GridItemStyle-"] {
                    flex-basis: 243px;
                    max-width: 243px;

                    @media only screen and (max-width: 540px) {
                        flex-basis: 173px;
                        max-width: 173px;
                    }
                }

                > div {
                    justify-content: center;
                    gap: 16px;
                    margin: 0;
                    @media only screen and (max-width: 768px) {
                        row-gap: 40px;
                    }

                    @media only screen and (max-width: 540px) {
                        column-gap: 8px;
                    }
                }
            }

            .industry-section-title {
                text-align: center;

                > [class*="GridOffset-"] {
                    margin-bottom: 24px;
                }

                p {
                    font-size: ${headlineFonts.headline2SemiBoldLg.fontSize};
                    line-height: ${headlineFonts.headline2SemiBoldLg.lineHeight};
                    font-weight: ${headlineFonts.headline2SemiBoldLg.fontWeight};
                    color: ${colorPallete.black90};
                    @media only screen and (max-width: 768px) {
                        font-size: ${headlineFonts.headline1SemiBoldSm.fontSize};
                        line-height: ${headlineFonts.headline1SemiBoldSm.lineHeight};
                    }
                }
            }
            .industry-block {
                background: ${colorPallete.primaryRed500};
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                border-radius: 8px;
                > a {
                    padding: 16px 8px 24px;
                    font: ${bodyFonts.body1SemiBoldLg.fontWeight} ${bodyFonts.body1SemiBoldLg.fontSize}/${bodyFonts.body1SemiBoldLg.lineHeight} ${bodyFonts.body1SemiBoldLg.fontFamily};
                    display: flex;
                    width: 100%;
                    justify-content: center;
                    > span {
                        display: flex;
                        flex-direction: column;
                        text-align: center;
                        gap: 8px;
                        align-items: center;
                    }
                }
                &:hover {
                    outline: 2px solid ${colorPallete.primaryMaroon500};
                    box-shadow: ${elevation.dp04};
                    cursor: pointer;
                }

                p {
                    margin: 0;
                    font-size: ${bodyFonts.body1SemiBoldLg.fontSize};
                    line-height: ${bodyFonts.body1SemiBoldLg.lineHeight};
                    font-weight: ${bodyFonts.body1SemiBoldLg.fontWeight};
                    color: ${colorPallete.white};
                    text-align: center;
                    margin-top: 8px;
                }

                & + .industry-block-content {
                    ul {
                        list-style: none;
                        padding: 0;
                        margin: 0;
                    }
                    p, li {
                        text-align: center;
                        margin-bottom: 0;
                        font-size: ${buttonFonts.buttonLg.fontSize};
                        line-height: ${buttonFonts.buttonLg.lineHeight};
                        a {
                            font-size: ${buttonFonts.buttonLg.fontSize};
                            line-height: ${buttonFonts.buttonLg.lineHeight};
                            font-weight: ${buttonFonts.buttonLg.fontWeight};
                            margin-top: 16px;
                            color: ${colorPallete.grey800};

                            @media only screen and (max-width: 540px) {
                                font-size: ${buttonFonts.buttonSm.fontSize};
                                line-height: ${buttonFonts.buttonSm.lineHeight};
                                text-decoration: underline;
                            }
                        }

                        &:hover {
                            a {
                                span {
                                    color: ${colorPallete.primaryRed500};
                                }
                            }
                        }
                    }
                }

                @media only screen and (max-width: 768px) {
                   

                    img {
                        max-width: 80px;
                    }

                    p, li {
                        font-size: ${bodyFonts.body2SemiBoldSm.fontSize};
                        line-height: ${bodyFonts.body2SemiBoldSm.lineHeight};
                        font-weight: ${bodyFonts.body2SemiBoldSm.fontWeight};
                        margin-top: 0;
                    }
                    > a {
                        font-size: ${bodyFonts.body2SemiBoldSm.fontSize};
                        line-height: ${bodyFonts.body2SemiBoldSm.lineHeight};
                        margin-top: 0;
                        padding: 8px;
                        > span {
                            gap: 0;
                        }
                    }
                }
            }

            [data-test-selector*="facetFilter"] {
                label {
                    a {
                        &:focus {
                            outline-offset: -1px;
                        }
                        &:focus:not(:focus-visible) {
                            outline-offset: 0;
                        }
                    }
                }
            }

            /* One Team Building Features */
            [class*="GridWrapper-"].one-team-building-row {
                padding: 0 24px;
                @media only screen and (max-width: 768px) {
                    padding: 0 24px;
                }
                > [class*="GridOffset-"] {
                    margin: 0;
                    margin-bottom: 48px;
                    width: 100%;
                    gap: 19px;
                    justify-content: center;
                    flex-wrap: nowrap;

                    [class*="Wrapper-"] {
                        height: 100%;
                    }

                    [class*="GridItemStyle-"] {
                        flex-basis: 413px;
                        max-width: 413px;
                    }

                    @media only screen and (max-width: 768px) {
                        gap: 24px;
                        margin-bottom: 28px;
                        flex-direction: column;

                        [class*="GridItemStyle-"] {
                            flex-basis: 100%;
                            max-width: 100%;
                        }
                    }
                }
            }

            [class*="Wrapper-"] {
                [class*="TypographyStyle-"] {
                    &.one-team-section-heading {
                        margin-bottom: 24px;
                        margin-top: 48px;
                        font-size: ${headlineFonts.headline2SemiBoldLg.fontSize};
                        color: ${colorPallete.grey800};
                        line-height: ${headlineFonts.headline2SemiBoldLg.lineHeight};
                        font-weight: ${headlineFonts.headline2SemiBoldLg.fontWeight};

                        @media only screen and (max-width: 768px) {
                            margin: 24px 0;
                            font-size: ${headlineFonts.headline1SemiBoldSm.fontSize};
                            line-height: ${headlineFonts.headline1SemiBoldSm.lineHeight};
                            font-weight: ${headlineFonts.headline1SemiBoldSm.fontWeight};
                        }
                    }
                }
            }

            .one-team-section {
                @media only screen and (max-width: 768px) {
                    padding: 0 16px;
                }
            }

            @media only screen and (min-width: 1279px) {
                [data-test-selector="pageBreadcrumbs"] {
                    padding-left: 0 !important;
                    padding-right: 0 !important;
                }
            }

            [data-test-selector="page_DsgCustomPage"] main div [class*="ContentWrapper"] .dsg-container {
                max-width: 1440px !important;
                margin: auto auto 20px;
                padding: 0 16px;
            }
            [data-test-selector="page_NewsListPage"] main > div > div > div {
                max-width: 1440px !important;
                margin: auto;
            }
            [data-test-selector="page_NewsListPage"] {
                main > div > div > [class*="ContentWrapper"] {
                    max-width: 100% !important;
                }
            }
            [data-test-selector="page_Page"] {
                main[class*="PageStyle"] > [class*="Wrapper"] > div:first-child {
                    max-width: 100% !important;
                }
            }
            
            [data-test-selector="page_DsgCustomPage"] {
                main[class*="PageStyle"] .img-wrapper {
                    max-width: 1440px !important;
                    margin: auto;
                }
            }
            [data-test-selector="page_DsgCustomPage"],
            [data-test-selector="page_Page"] {
                main[class*="PageStyle"] dd {
                    margin: 0;
                }
            }
            [data-test-selector="page_DsgCustomPage"] main[class*="PageStyle"] [class*="ContentWrapper"] > table,
            [data-test-selector="page_Page"] main[class*="PageStyle"] [class*="ContentWrapper"] > table {
                background: transparent !important;
            }
            [data-test-selector="page_DsgCustomPage"] main[class*="PageStyle"] [class*="ContentWrapper"] > table span,
            [data-test-selector="page_Page"] main[class*="PageStyle"] [class*="ContentWrapper"] > table span {
                color: ${colorPallete.grey900} !important;
            }
            [data-test-selector="page_DsgCustomPage"]
                main[class*="PageStyle"]
                [class*="ContentWrapper"]
                > table
                tr
                td:nth-child(2),
            [data-test-selector="page_Page"]
                main[class*="PageStyle"]
                [class*="ContentWrapper"]
                > table
                tr
                td:nth-child(2) {
                display: table-cell;
            }
            [data-test-selector="page_DsgCustomPage"] {
                main[class*="PageStyle"] {
                    max-width: 100%;
                    padding-left: 24px;
                    padding-right: 24px;
                    padding-bottom: 48px !important;

                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        css`
                            padding-left: 16px;
                            padding-right: 16px;
                        `,
                        null,
                        null,
                    ], "max")}
                }
            }
            [data-test-selector="page_NewsPage"],
            [data-test-selector="page_NewsListPage"] {
                main[class*="PageStyle"] {
                    max-width: 100%;
                    padding-left: 16px;
                    padding-right: 16px;
                }
            }
            [data-test-selector="page_Page"] {
                main[class*="PageStyle"] {
                    padding: 24px 16px 40px !important;
                }
            }
            @media screen and (max-width: 767px) {
                [data-test-selector="page_Page"]
                    main[class*="PageStyle"]
                    > [class*="Wrapper"]
                    > div
                    [class*="GridItem"] {
                    max-width: 100%;
                    flex-basis: 100%;
                }
            }

            [data-test-selector="page_DsgCustomPage"],
            [data-test-selector="page_Page"] {
                main[class*="PageStyle"] {
                    .wrapper {
                        ul {
                            li {
                                p {
                                    margin: 0;
                                }
                            }
                        }
                        h1,
                        h2 {
                            span {
                                color: ${colorPallete.grey800}!important;
                            }
                        }
                        h3 {
                            span {
                                color: ${colorPallete.grey800}!important;
                            }
                        }
                    }
                    

                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                css`
                                    [class*="GridOffset"] {
                                        [class*="GridItemStyle"] {
                                            max-width: 100%;
                                            flex-basis: 100%;
                                        }
                                    }
                                `,
                            ],
                            "max",
                        )}
                }
            }

            .cms-content {
                hr.borderBelowHeading {
                    margin: 24px 0 !important;
                }
                &.padding-0 {
                    [class*="GridOffset"] {
                        padding-bottom: 0;
                    }
                }
                h5 {
                    font: ${headlineFonts.headline4SemiBoldSm.fontWeight} ${headlineFonts.headline4SemiBoldSm.fontSize}/${headlineFonts.headline4SemiBoldSm.lineHeight} ${headlineFonts.headline4SemiBoldSm.fontFamily};
                    margin-bottom: 16px;
                    color: ${colorPallete.grey800};
                }
                h3 {
                    font: ${headlineFonts.headline3SemiBoldSm.fontWeight} ${headlineFonts.headline3SemiBoldSm.fontSize}/${headlineFonts.headline3SemiBoldSm.lineHeight} ${headlineFonts.headline3SemiBoldSm.fontFamily};
                    margin-bottom: 24px;
                }
                .img-wrapper {
                    margin-bottom: 16px;
                }
                .wrapper {
                    .dsg-container {
                        margin-bottom: 9px;
                    }
                    p {
                        font: ${bodyFonts.body1RegularSm.fontWeight} ${bodyFonts.body1RegularSm.fontSize}/${bodyFonts.body1RegularSm.lineHeight} ${bodyFonts.body1RegularSm.fontFamily};
                        margin-bottom: 16px;
                        display: block;
                        &:last-child {
                            margin-bottom: 0;
                        }
                    }
                    .mb-0 {
                        margin-bottom: 0;
                    }
                    dt p {
                        margin-bottom: 0;
                    }
                    dd > ul {
                        margin-top: 0;
                    }
                    li {
                        font: ${bodyFonts.body1RegularSm.fontWeight} ${bodyFonts.body1RegularSm.fontSize}/${bodyFonts.body1RegularSm.lineHeight} ${bodyFonts.body1RegularSm.fontFamily};
                        color: ${colorPallete.grey800};
                    }
                    ul {
                        li {
                            p {
                                margin: 0;
                            }
                        }
                    }
                    h1 {
                        font: ${headlineFonts.headline1SemiBoldSm.fontWeight}  ${headlineFonts.headline1SemiBoldSm.fontSize}/ ${headlineFonts.headline1SemiBoldSm.lineHeight}  ${headlineFonts.headline1SemiBoldSm.fontFamily};
                        color: ${colorPallete.grey800};
                        margin-bottom: 9px;
                    }
                    h2 {
                        span {
                            font: ${headlineFonts.headline1SemiBoldSm.fontWeight}  ${headlineFonts.headline1SemiBoldSm.fontSize}/ ${headlineFonts.headline1SemiBoldSm.lineHeight}  ${headlineFonts.headline1SemiBoldSm.fontFamily};
                            margin-bottom: 1rem;
                            color: ${colorPallete.grey800}!important;
                            span {
                                color: ${colorPallete.grey800}!important;
                            }
                        }
                    }
                    h3 {
                        span {
                            font-size: 32px !important;
                            color: ${colorPallete.grey800}!important;
                            font-weight: 600;
                        }
                    }
                }
                p {
                    font: ${bodyFonts.body1RegularSm.fontWeight} ${bodyFonts.body1RegularSm.fontSize}/${bodyFonts.body1RegularSm.lineHeight} ${bodyFonts.body1RegularSm.fontFamily};
                    margin-bottom: 16px;
                    display: block;
                    color: ${colorPallete.grey800};
                }
                li {
                    font: ${bodyFonts.body1RegularSm.fontWeight} ${bodyFonts.body1RegularSm.fontSize}/${bodyFonts.body1RegularSm.lineHeight} ${bodyFonts.body1RegularSm.fontFamily};
                }
                .paraLink {
                    a {
                        &.text-link {
                            font-size: ${bodyFonts.body1SemiBoldSm.fontSize};
                            line-height: ${bodyFonts.body1SemiBoldSm.lineHeight};
                        }
                    }
                }
                a {
                    color: ${colorPallete.primaryRed500}!important;
                    &.text-link {
                        font: ${buttonFonts.buttonSm.fontWeight} ${buttonFonts.buttonSm.fontSize}/${buttonFonts.buttonSm.lineHeight} ${buttonFonts.buttonSm.fontFamily};
                    }
                    &.text-link-secondary {
                        color: ${colorPallete.grey800} !important;
                        span {
                            color: ${colorPallete.grey800} !important;
                        }
                    }
                    span {
                        color: ${colorPallete.primaryRed500}!important;
                    }
                    &:hover,
                    &:active,
                    &:focus {
                        text-decoration: underline;
                        color: ${colorPallete.primaryRed500}!important;
                        span {
                            color: ${colorPallete.primaryRed500}!important;
                            text-decoration: underline;
                        }
                    }
                    &.btn-primary {
                        color: ${colorPallete.white};
                        span {
                            color: ${colorPallete.white}!important;
                        }
                        padding-top: 5px;
                        padding-bottom: 5px;
                        min-height: 38px;
                        display: inline-flex;
                        margin: 15px 0;
                        &:hover {
                            color: ${colorPallete.white}!important;
                            text-decoration: none;
                            span {
                                color: ${colorPallete.white}!important;
                                text-decoration: none;
                            }
                        }
                    }
                }
                hr {
                    display: block;
                    border: none;
                    margin: 24px 0 !important;
                    border-bottom: 1px solid ${colorPallete.grey300};
                }

                h1 {
                    font: ${headlineFonts.headline1SemiBoldSm.fontWeight}  ${headlineFonts.headline1SemiBoldSm.fontSize}/ ${headlineFonts.headline1SemiBoldSm.lineHeight}  ${headlineFonts.headline1SemiBoldSm.fontFamily};
                    margin-bottom: 9px;
                    color: ${colorPallete.grey800};
                }
                h2 {
                    font: ${headlineFonts.headline1SemiBoldSm.fontWeight}  ${headlineFonts.headline1SemiBoldSm.fontSize}/ ${headlineFonts.headline1SemiBoldSm.lineHeight}  ${headlineFonts.headline1SemiBoldSm.fontFamily};
                    color: ${colorPallete.grey800}!important;
                    span {
                        font-weight: 600;
                        line-height: 49.4px;
                        font-size: 38px;
                        color: ${colorPallete.grey800}!important;
                    }
                }

            }

            .cms-carousel {
                text-align: center;
                margin: 25px 0;
                h2 {
                    color: ${colorPallete.primaryRed500}!important;
                    font-weight: 400;
                }
                .rich-content-spot-2 {
                    background: ${colorPallete.grey100};
                    border-top: 2px solid ${colorPallete.grey800};
                    border-bottom: 2px solid ${colorPallete.grey800};
                    padding: 25px 0;
                    margin-bottom: 25px;
                }
                ul {
                    display: block !important;
                    list-style: none;
                    white-space: nowrap;
                    overflow-x: auto;
                    margin: 0 auto !important;
                    li {
                        display: inline-block;
                        img {
                            max-width: 200px;
                            display: block;
                        }
                    }

                    /* width */
                    ::-webkit-scrollbar {
                        width: 6px;
                        height: 6px;
                    }

                    /* Track */
                    ::-webkit-scrollbar-track {
                        box-shadow: inset 0 0 3px ${colorPallete.grey400};
                        border-radius: 6px;
                    }

                    /* Handle */
                    ::-webkit-scrollbar-thumb {
                        background: ${colorPallete.grey800};
                        border-radius: 6px;
                        cursor: pointer;
                    }

                    /* Handle on hover */
                    ::-webkit-scrollbar-thumb:hover {
                        background: ${colorPallete.grey200};
                    }
                }
                .button {
                    &.primary {
                        background: ${colorPallete.primaryRed500};
                        color: ${colorPallete.white}!important;
                        font-weight: 600;
                        text-transform: uppercase;
                        padding: 5px 25px;
                        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
                        font-size: 18px;
                        display: inline-block;
                        margin-bottom: 10px;
                        border-radius: 5px;
                        span {
                            color: ${colorPallete.white}!important;
                        }
                        &:hover {
                            text-decoration: none;
                            span {
                                text-decoration: none;
                            }
                        }
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    null,
                                    css`
                                        font-size: 16px;
                                    `,
                                ],
                                "max",
                            )}
                    }
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        .cms-content {
                            [class*="GridOffset"] {
                                gap: 40px;
                            }
                            .paraLink {
                                a {
                                    &.text-link {
                                        font-size: ${bodyFonts.body1SemiBoldLg.fontSize};
                                        lin-height: ${bodyFonts.body1SemiBoldLg.lineHeight};
                                    }
                                }
                            }
                            hr {
                                margin: 24px 0 !important;
                            }
                            hr.borderBelowHeading {
                                margin: 24px 0 !important
                            }
                            a {
                                &.text-link {
                                    font-size: ${buttonFonts.buttonLg.fontSize};
                                    line-height: ${buttonFonts.buttonLg.lineHeight};
                                }
                            }
                            h1 {
                                font-size: ${headlineFonts.headline1SemiBoldLg.fontSize};
                                line-height: ${headlineFonts.headline1SemiBoldSm.lineHeight};
                            }
                            h2 {
                                font-size: ${headlineFonts.headline1SemiBoldLg.fontSize};
                                line-height: ${headlineFonts.headline1SemiBoldSm.lineHeight}
                            }
                            .wrapper {
                                h1 {
                                    font-size: ${headlineFonts.headline1SemiBoldLg.fontSize};
                                    line-height: ${headlineFonts.headline1SemiBoldSm.lineHeight};
                                    margin-bottom: 25px;
                                }
                                p {
                                    font-size: ${bodyFonts.body1RegularLg.fontSize};
                                    line-height: ${bodyFonts.body1RegularLg.lineHeight};
                                }
                                .dsg-container {
                                    margin-bottom: 0;
                                }
                                li {
                                    font-size: ${bodyFonts.body1RegularLg.fontSize};
                                    line-height: ${bodyFonts.body1RegularLg.lineHeight};
                                }
                            }
                            h5 {
                                font-size: ${headlineFonts.headline4SemiBoldLg.fontSize};
                                line-height: ${headlineFonts.headline4SemiBoldLg.lineHeight};
                            }
                            h3 {
                                font-size: ${headlineFonts.headline3SemiBoldLg.fontSize};
                                line-height: ${headlineFonts.headline3SemiBoldLg.lineHeight};
                                margin-bottom: 40px;
                            }
                            li {
                                font-size: ${bodyFonts.body1RegularLg.fontSize};
                                line-height: ${bodyFonts.body1RegularLg.lineHeight};
                            }
                            h1 {
                                font-size: ${headlineFonts.headline1SemiBoldLg.fontSize};
                                line-height: ${headlineFonts.headline1SemiBoldSm.lineHeight};
                                margin-bottom: 40px;
                            }
                            p {
                                font-size: ${bodyFonts.body1RegularLg.fontSize};
                                line-height: ${bodyFonts.body1RegularLg.lineHeight};
                            }
                            a {
                                &.btn-primary {
                                    min-height: 48px;
                                }
                            }
                        }
                    `,
                    css`
                        [data-test-selector="page_NewsListPage"] {
                            .cms-content {
                                max-width: 1280px;
                                > div{
                                    padding-left: 0 !important;
                                    padding-right: 0 !important;
                                }  
                            }
                        }
                        .cms-content {
                            [class*="GridOffset"] {
                                gap: 24px;
                                justify-content: space-between;
                                flex-wrap: nowrap !important;
                            }
                        }
                    `,
                ],
                "min",
            )}
            [data-test-selector="page_DsgCustomPage"],
            [data-test-selector="page_Page"] {
                main[class*="PageStyle"] ul {
                    margin-left: 24px;
                    padding-left: 0;
                    margin-bottom: 24px;
                }
            }
            [data-test-selector="page_DsgCustomPage"] {
                main[class*="PageStyle"] {
                    [class*="Wrapper"] {
                        max-width: 1280px;
                        margin: 0 auto;
                    }
                }
            }
           
            .smallHeadingLinesNotes [data-test-selector="text_Line Notes"] {
                font-size: 12px;
            }

            @media screen and (max-width: 1024px) {
                [data-test-selector="page_DsgCustomPage"]
                    main[class*="PageStyle"]
                    [class*="ContentWrapper"]
                    > table
                    tr
                    td:first-child,
                [data-test-selector="page_DsgCustomPage"]
                    main[class*="PageStyle"]
                    [class*="ContentWrapper"]
                    > table
                    tr
                    td:last-child,
                [data-test-selector="page_DsgCustomPage"]
                    main[class*="PageStyle"]
                    [class*="ContentWrapper"]
                    > table
                    tr
                    td:empty,
                [data-test-selector="page_Page"]
                    main[class*="PageStyle"]
                    [class*="ContentWrapper"]
                    > table
                    tr
                    td:first-child,
                [data-test-selector="page_Page"]
                    main[class*="PageStyle"]
                    [class*="ContentWrapper"]
                    > table
                    tr
                    td:last-child,
                [data-test-selector="page_Page"]
                    main[class*="PageStyle"]
                    [class*="ContentWrapper"]
                    > table
                    tr
                    td:empty {
                    display: none;
                }
            }
            [data-test-selector="page_DsgCustomPage"] main[class*="PageStyle"] iframe {
                max-width: 1440px;
                margin: auto;
                text-align: center;
                display: flex;
            }
       
            [data-test-selector="page_InvoiceDetailsPage"],
            [data-test-selector="page_SavedOrderDetailsPage"],
            [data-test-selector="page_OnePageCheckoutConfirmationPage"],
            [data-test-selector="page_OrderDetailsPage"] {
                .directionIconHidden {
                    display: none;
                }
            }
            [data-test-selector="page_NewsPage"] {
                main {
                    max-width: 100%;
                    [data-test-selector="PageTitle"] {
                        max-width: 1280px;
                        margin-left: auto;
                        margin-right: auto;
                    }
                    > div > div {
                        max-width: 1280px;
                        margin: auto;
                        > [class*="ContentWrapper"] {
                            max-width: 100% !important;
                        }
                    }
                }
                [data-test-selector="newslist_content"] > span {
                    width: auto;
                    height: auto;
                }
            }

            .modalBox {
                border-radius: 8px;
                padding: 24px;
                box-shadow: ${elevation.dp08};

                &.modal-delete {
                    max-width: 496px;
                }
            }

            .boxGrey {
                background: ${colorPallete.grey100};
                padding: 16px 16px 24px;
                border: 1px solid ${colorPallete.grey500};
                border-radius: 8px;
                margin-bottom: 24px !important;
            }
            .greyBoxWithBorder2416 {
                border-radius: 8px;
                padding: 24px 16px;
                background: ${colorPallete.grey50};
                border: 1px solid ${colorPallete.grey300};
            }
            .boxWithBorder2416 {
                padding: 24px 16px;
                border: 1px solid ${colorPallete.grey500};
                box-shadow: ${elevation.dp04};
                border-radius: 8px;
            }
            [class*="PageStyle"] {
                .no-bold {
                    font-weight: ${themeFontWeights.regular};
                }
                
                .boxWithBorder {
                    padding: 16px;
                    border: 1px solid ${colorPallete.grey500};
                    box-shadow: ${elevation.dp04};
                    border-radius: 8px;
                    &,
                    &[class*="GridItemStyle"] {
                        margin-bottom: 24px;
                    }
                }
            }
            .orderInfoBluebox {
                border: 1px solid ${colorPallete.semanticBlue500};
                border-left: 8px solid ${colorPallete.semanticBlue500};
                color: ${colorPallete.semanticBlue500};
                font-size: ${labelFonts.label1Regular.fontSize};
                line-height: ${labelFonts.label1Regular.lineHeight};
                border-radius: 4px;
                padding: 16px 24px 16px 16px;
                display: flex;
                gap: 16px;
                align-items: center;
                margin-top: 20px;
            }

            .accordionMobileOnly {
                &.boxGrey {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                css`
                                    margin-bottom: 0 !important;
                                `,
                            ],
                            "max",
                        )}
                    dt,
                    dd,
                    dt > button {
                        border: none;
                        padding: 0;
                        background: transparent;
                    }
                    dt > button {
                        span {
                            font: ${bodyFonts.body1SemiBoldLg.fontWeight}
                                ${bodyFonts.body1SemiBoldLg.fontSize} /
                                ${bodyFonts.body1SemiBoldLg.lineHeight}
                                ${bodyFonts.body1SemiBoldLg.fontFamily};
                            color: ${colorPallete.grey800};
                        }
                        [class*="TransitionManager"] {
                            top: 0;
                            bottom: 0;
                        }
                    }
                    dd {
                        padding-top: 16px;
                        ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    padding-top: 0;
                                `,
                            ],
                            "min",
                        )}
                    }
                }

                + div {
                    &.boxGrey {
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    css`
                                        display: none !important;
                                    `,
                                ],
                                "max",
                            )}
                    }
                }
            }
            body {
                main .priceLoadFailed {
                    color: ${colorPallete.grey600};
                    font: ${bodyFonts.body2RegularLg.fontWeight} ${bodyFonts.body2RegularLg.fontSize} /
                        ${bodyFonts.body2RegularLg.lineHeight} ${bodyFonts.body2RegularLg.fontFamily};
                }
                .mobile-only {
                    display: none !important;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                css`
                                    display: block !important;
                                `,
                            ],
                            "max",
                        )}
                }
            }
            [data-test-selector="pagination_previousButton"],
            [data-test-selector="pagination_nextButton"] {
                &,
                &:disabled {
                    background: none;
                }
                &:disabled {
                    border: none;
                }
            }
            [data-test-selector="pagination_previousButton"],
            [data-test-selector="pagination_nextButton"] {
                &,
                &:disabled {
                    background: none;
                }

                &:disabled {
                    border: none;
                }

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                padding-left: 10px;
                                padding-right: 10px;
                            `,
                            null,
                        ],
                        "max",
                    )}
            }
            [data-test-selector="page_NewsPage"] {
                [class*="PageLayoutWrapper"] {
                    > div[class*="PageStyle"] {
                        max-width: 1440px;  
                        padding-left: 24px;
                        padding-right: 24px;
                        padding-bottom: 0;
                    }
                    [data-test-selector="pageBreadcrumbs"] {
                        padding-bottom: 0;
                    }
                }
                div [data-test-selector="pageBreadcrumbs"] {
                    max-width: 1280px;
                    padding-left: 0;
                    padding-right: 0;
                    flex-wrap: wrap;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            .boxGrey {
                                padding: 24px;
                            }
                            .accordionMobileOnly {
                                &.boxGrey {
                                    dt button {
                                        [class*="IconWrapper"] {
                                            display: none;
                                        }
                                    }
                                    dt {
                                        button {
                                            display: none !important;
                                        }
                                    }
                                    .headingGreySectionDesktop {
                                        margin-bottom: 16px;
                                    }

                                    .headingGreySectionDesktop,
                                    dt > button span {
                                        font-size: ${headlineFonts.headline4SemiBoldLg.fontSize};
                                        line-height: ${headlineFonts.headline4SemiBoldLg.lineHeight};
                                        font-weight: ${headlineFonts.headline4SemiBoldLg.fontWeight};
                                    }
                                    dd {
                                        display: block;
                                    }
                                }
                            }
                            [class*="PageStyle"] {
                                .boxWithBorder {
                                    padding: 24px;
                                }
                            }
                            .boxWithBorder2416 {
                                padding: 24px;
                            }
                            .greyBoxWithBorder2416 {
                                padding: 24px;
                            }
                        `,
                        css`
                            [data-test-selector="page_NewsPage"],
                            [data-test-selector="page_DsgCustomPage"],
                            [data-test-selector="page_NewsListPage"],
                            [data-test-selector="page_Page"] {
                                main[class*="PageStyle"] {
                                    padding: 24px 24px 48px !important;
                                }
                            }
                            [data-test-selector="page_NewsPage"] {
                                [class*="PageLayoutWrapper"] {
                                    > div {
                                        padding-left: 24px;
                                        padding-right: 24px;
                                        padding-bottom: 0;
                                    }
                                }
                            }
                        `,
                    ],
                    "min",
                )}

                @media only screen and (min-width: 1346px) {
                    [data-test-selector="page_NewsPage"],
                    [data-test-selector="page_DsgCustomPage"],
                    [data-test-selector="page_NewsListPage"],
                    [data-test-selector="page_Page"] {
                        main[class*="PageStyle"] {
                            padding: 24px 80px 48px !important;
                        }
                    }
                    [data-test-selector="page_NewsPage"] {
                        [class*="PageLayoutWrapper"] {
                            > div {
                                padding-left: 80px !important;;
                                padding-right: 80px !important;;
                            }
                        }
                    }
                }
                [data-test-selector="page_HomePage"] {
                    .product-expanded-grid-carousel {
                        &.product-carousel {
                            width: 100%;
                            margin: 24px 0 0px;
                        }
                    }
                }
            [data-test-selector="page_ProductDetailsPage"] {
                .product-expanded-grid-carousel {
                    &.product-carousel {
                        width: calc(100% + 32px);
                        margin: 24px -16px 0px;
                    }
                }
            }
       
            [data-test-selector="page_CartPage"] {
                .product-expanded-grid-carousel {
                    &.product-carousel {
                        width: calc(100% + 32px);
                        margin: 0 -16px;
                    }
                }
            }
            [data-test-selector="page_BrandDetailsPage"],
            [data-test-selector="page_ProductListPage"] {
                .inventoryFailedToLoad,
                .availableForPurchase {
                    display: none;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        null,
                        css`
                            [data-test-selector="page_CartPage"] {
                                .product-expanded-grid-carousel {
                                    &.product-carousel {
                                        width: calc(100% + 160px);
                                        margin: 0 -80px;
                                    }
                                }
                            }
                            [data-test-selector="page_ProductDetailsPage"] {
                                .product-expanded-grid-carousel {
                                    &.product-carousel {
                                        width: calc(100% + 48px);
                                        margin: 24px -24px 0px;
                                    }
                                }
                            }
                        `,
                    ],
                    "min",
                )}
                @media screen and (min-width: 1024px) and (max-width: 1366px) {
                    [data-test-selector="page_CartPage"] {
                        .product-expanded-grid-carousel {
                            &.product-carousel {
                                width: calc(100% + 48px);
                                margin: 0 -24px;
                            }
                        }
                    }
                }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            .recommendation-carousel {
                                [data-test-selector="slides"] > div {
                                    max-width: 50%;
                                }
                            }
                        `,
                    ],
                    "minMax",
                )}
            [aria-haspopup="listbox"] {
                [class*="PopoverStyle"] {
                    top: auto;
                    width: 100%;
                }
            }
            #react-app > div:not([data-test-selector="page_ProductDetailsPage"]),
            [data-test-selector="myListDetails_line"]  {
                .productAvailability {
                    > div {
                        > [class*="GridItemStyle"] {
                            flex-direction: column;
                        }
                    }
                    .inventoryWrapper {
                        p {
                            font-size: ${labelFonts.label1Regular.fontSize};
                            line-height: ${labelFonts.label1Regular.lineHeight};
                        }
                        svg {
                            width: 16px;
                            height: 16px;
                            min-width: 16px;
                        }
                    }
                    .inventoryLinkWrapper {
                        button {
                            font-size: ${labelFonts.label1Regular.fontSize};
                            line-height: ${labelFonts.label1Regular.lineHeight};
                        }
                    }
                }
            }

            [data-test-selector="page_DealerDetailsPage"] {
                [data-test-selector="pageBreadcrumbs"] {
                    margin: 0 auto;
                    padding-left: 0;
                }
            }

            [data-test-selector="page_InvoiceDetailsPage"] {
                [data-test-selector="pageBreadcrumbs"] {
                    padding-left: 0;
                }
            }

            
            //My List/Wishlist page
            [data-test-selector="page_MyListsDetailsPage"] {
                main[class*="PageStyle"] {
                    max-width: 1280px;
                    margin: 0 auto;
                    
                }
            }
            .text-elips {
                display: -webkit-box;
                overflow: hidden;
                width: 90%;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                -webkit-line-clamp: 3;
                                font-size: 14px;
                                margin-bottom: 5px;
                            `,
                            null,
                            null,
                            css`
                                justify-content: flex-start;
                            `,
                        ],
                        "max",
                    )}
            }
            .added-item-date {
                font-size: ${labelFonts.label1Regular.fontSize};
                white-space: nowrap;
                display: block;
                width: 100%;
                color: ${colorPallete.grey600DisabledText};
                text-align: right;
                padding: 12px 0 0;
                span {
                    padding: 0 0 0 4px;
                    display: inline-block;
                    color: ${colorPallete.grey600};
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                text-align: left;
                                span {
                                    padding: 0 4px 0 0;
                                }
                            `,
                        ],
                        "max",
                    )}
                @media print {
                    padding: 0;
                    &,
                    [data-test-selector="purchasedDate"] {
                        font-size: ${printFonts.bodyRegularSm.fontSize};
                        line-height: ${printFonts.bodyRegularSm.lineHeight};
                        text-align: right;
                    }
                    span {
                        padding: 0;
                    }
                }
            }

            .part-number {
                display: flex;
                justify-content: flex-start;
                color: ${colorPallete.grey800};
                legend {
                    padding: 0;
                    color: ${colorPallete.grey800};
                }
                div {
                    margin: 0;
                    display: flex !important;
                    width: auto !important;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                [class*="GridOffset"] {
                                    flex-direction: column;
                                    [class*="GridOffset"] {
                                        flex-direction: column;
                                    }
                                }
                            `,
                        ],
                        "max",
                    )}
            }

            .qty-box-container {
                > div {
                    display: block !important;
                    float: right;
                    margin: 0 !important;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                css`
                                    float: left;
                                    margin-top: 11px !important;
                                    margin-bottom: 4px !important;
                                `,
                            ],
                            "max",
                        )}
                    @media print {
                        margin: 0 !important;
                        float: none;
                    }
                }
                .number-input {
                    margin-bottom: 0 !important;
                    button {
                        min-height: 36px;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    null,
                                    css`
                                        min-height: 32px;
                                    `,
                                ],
                                "max",
                            )}
                    }
                }
            }
            .menu-Wrapper {
                display: flex;
                flex-direction: column !important;
                .activePopover {
                    [class*="IconWrapper"] {
                        transform: rotate(0);
                    }
                }
                > nav {
                    width: 100%;
                    text-align: right;
                    height: auto;
                    margin-bottom: 30px;
                    > button {
                        background: none !important;
                        font-size: 16px;
                        width: auto;
                        height: auto;
                        min-height: 0;
                        > span {
                            color: ${colorPallete.primaryRed500}!important;
                            font-weight: 600;
                            &:not(:focus):not(:active) {
                                color: ${colorPallete.primaryRed500}!important;
                                position: relative;
                                width: auto;
                                height: auto;
                                clip-path: unset;
                                margin: 0;
                            }
                        }
                        svg {
                            position: relative;
                            top: 5px;
                        }
                    }
                }
                ul {
                    border: 1px solid ${colorPallete.grey300};
                    box-shadow: 8px 8px 8px ${colorPallete.grey500};
                    padding: 0;
                    border-radius: 8px;
                    max-height: 100%;
                    width: 235px;
                    margin-left: -45px;
                    li {
                        white-space: nowrap;
                        button {
                            &:active,
                            &:focus span {
                                background: none;
                                color: ${colorPallete.black};
                            }
                            text-align: left;
                            [class*="IconWrapper"] {
                                transform: rotate(0);
                            }
                            padding: 10px 15px;
                            span {
                                display: inline-block !important;
                                padding: 0;
                                width: fit-content;
                                margin-right: 5px;
                                font-size: 16px;
                                &[class*="IconWrapper"] {
                                    transform: rotate(0);
                                }
                                svg {
                                    width: 20px;
                                    height: 20px;
                                    position: relative;
                                    top: 3px;
                                    &:active,
                                    &:focus {
                                        background: none;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .my-list-update {
                input.form-input:not(.react-datetime-picker__inputGroup__input) {
                    border: 1px solid ${colorPallete.black};
                    font-size: 38px;
                    font-weight: 600;
                    color: ${colorPallete.black};
                }
                input.input-form-desc:not(.react-datetime-picker__inputGroup__input) {
                    font-size: 16px;
                    color: ${colorPallete.black};
                    border: 1px solid ${colorPallete.black};
                }
                .btn-secondary {
                    span {
                        color: ${colorPallete.primaryRed500};
                    }
                    &:hover {
                        span {
                            color: ${colorPallete.white};
                        }
                    }
                }
                .update-container {
                    display: flex;
                    flex-direction: column;
                }
            }
            .save-price {
                .price {
                    display: none;
                }
            }

            
               


            [class*="TagStyle"] {
                [class*="ButtonWrapper"] {
                    min-height: auto !important;
                    position: relative;
                }
            }

            //For Pagination
            .pagination {
                width: 100%;
                padding-top: 20px !important;
                justify-content: center !important;
                [class*="GridItemStyle"] {
                    justify-content: center;
                }
                [class*="LinkList"] {
                    flex-direction: column;
                }
                .pagination-text {
                    display: block !important;
                    text-align: center;
                    margin-top: 16px;
                    color: ${colorPallete.grey800};
                    font-size: ${bodyFonts.body2RegularSm.fontSize};
                    line-height: ${bodyFonts.body2RegularSm.lineHeight};
                    span {
                        font-weight: 600;
                        display: inline-block;
                    }
                }
                svg {
                    position: relative;
                    top: -2px;
                }
                &.align-right {
                    [class*="GridItemStyle"] {
                        justify-content: flex-end;
                    }
                }
                &.align-left {
                    .pagination {
                        justify-content: flex-start !important;
                    }
                    [class*="GridItemStyle"] {
                        justify-content: flex-start;
                    }
                }
            }

            .hideDatepickerPlaceholder {
                .nonSelectedDayTesting.emptyTesting {
                    .react-datetime-picker__inputGroup__input,
                    .react-datetime-picker__inputGroup__divider,
                    .react-datetime-picker__inputGroup__leadingZero {
                        opacity: 0;
                    }
                }
            }
            .react-datetime-picker__wrapper,
            .react-datetime-picker__inputGroup__leadingZero {
                font-size: ${bodyFonts.body2RegularLg.fontSize};
                line-height: ${bodyFonts.body2RegularLg.lineHeight};
            }
            [class*="FormFieldStyle"] {
                [class*="FormInputWrapper"] {
                    select + [class*="IconWrapper"] {
                        width: 40px;
                        svg {
                            height: 24px;
                            width: 24px;
                        }
                    }
                }
            }

            .date-range-container {
                width: 100%;
                max-width: 100% !important;
                [class*="GridOffset"] {
                    padding: 0 !important;
                    margin: 0;
                    width: auto !important;
                    > div {
                        padding: 0;
                    }
                }
                .date-range-picker {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap !important;
                    width: 100%;
                    label {
                        display: block;
                        margin: 0 5px 0 0;
                    }
                    [class*="FormFieldStyle"] {
                        display: flex;
                        align-items: center;
                        flex-direction: row;
                        label {
                            width: auto;
                            white-space: nowrap;
                            width: 60px;
                            padding-right: 10px;
                        }
                        [class*="FormInputWrapper"] {
                            margin-top: 0;
                        }
                    }
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    flex-wrap: wrap !important;
                                `,
                            ],
                            "max",
                        )}
                }
                label {
                    font-size: 14px;
                    font-weight: 600;
                    margin-bottom: 5px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                css`
                                    margin-bottom: 16px;
                                `,
                            ],
                            "max",
                        )}
                }
                [class*="IconWrapper"] svg {
                    color: ${colorPallete.grey800};
                }
            }
            .filterDateRange {
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            &.date-range-container {
                                .date-range-picker {
                                    [class*="FormFieldStyle"] label {
                                        width: auto;
                                    }
                                }
                                label {
                                    margin-bottom: 4px;
                                }
                            }
                        `,
                    ],
                    "min",
                )}
               
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            &.date-range-container {
                                .date-range-picker {
                                    flex-wrap: initial !important;
                                }
                            }
                        `,
                    ],
                    "minMax",
                )}
                &.date-range-container {
                    .date-range-picker {
                        [class*="FormFieldStyle"] label {
                            margin-right: 0;
                            padding-right: 8px;
                            font-weight: 400;
                            color: ${colorPallete.black};
                        }
                    }
                    .react-datetime-picker__inputGroup {
                        margin-left: 8px;
                    }
                    .react-datetime-picker__wrapper {
                        height: 52px;
                    }
                    .react-datetime-picker__wrapper {
                        position: relative;
                    }
                  
                    .react-datetime-picker__inputGroup {
                        position: absolute;
                        left: 40px;
                        top: 0;
                        width: calc(100% - 48px);
                        height: 54px;
                    }
                    .react-datetime-picker__calendar-button {
                        width: 24px;
                        padding: 0 !important;
                        span {
                            margin-right: 0;
                        }
                    }
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                .react-calendar {
                                    right: 0;
                                    left: auto;
                                }
                            `,
                        ],
                        "max",
                    )}
                }
            }
            .history-date-range {
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            null,
                            css`
                                [class*="GridItemStyle"] {
                                    max-width:100%;!important;
                                    flex-basis:100%!important;
                                }
                            `,
                        ],
                        "max",
                    )}
            }

            .edit-list-container {
                border: 1px solid ${colorPallete.grey500};
                border-radius: 8px;
                padding: 24px 40px;
                box-shadow: ${elevation.dp04};
                > div > div {
                    padding: 0;
                }
                > [class*="GridOffset"] {
                    width: 100%;
                    margin: 0;
                }
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            .edit-list-container {
                                padding: 16px;
                            }
                        `,
                        css`
                            .desktop-only {
                                display: none !important;
                            }
                        `,
                    ],
                    "max",
                )}
            .edit-list-container {
                @media print {
                    padding: 8px 16px;
                    background: ${colorPallete.grey200};
                    border: 1px solid ${colorPallete.grey500};
                    border-radius: 0;
                    box-shadow: none;
                }
            }
            /*Check Box*/
                [data-test-selector="selectAllItems"],
                [data-test-selector="myListDetails_selectRowCheckbox"] {
                span[role="checkbox"] {
                    border: 2px solid ${colorPallete.black}!important;
                    width: 18px !important;
                    height: 18px !important;
                    border-radius: 3px !important;
                    cursor: pointer;
                    position: relative;
                    top: 2px;
                    &:focus {
                       outline-offset: 1px;
                    }
                }
            }
            .boxCheckboxGroupWrapper {
                span[role="checkbox"]:focus + label {
                    outline-offset: 1px;
                }
            }
            [data-test-selector="page_MyListsDetailsPage"] {
                [data-test-selector="productSelector_qty"] {
                    min-height: 48px !important;
                }
            }
            [data-test-selector="wishListSearch"],
                [data-test-selector="productSelector_search-input"] {
                    padding: 8px 8px 8px 48px !important;
                    border: 1px solid ${colorPallete.grey400};
                    border-radius: 64px !important;
                    min-height: 48px !important;
                    &:focus {
                        padding: 8px 8px 8px 48px !important;
                        border: 1px solid ${colorPallete.grey400};
                        border-radius: 64px !important;
                        min-height: 48px;
                    }
                    & + [class*="IconWrapper"] {
                        left: 4px;
                        top: 0 !important;
                        right: auto !important;
                        left: 5px !important;
                        display:inline-flex!important;
                        height: 48px !important;
                        [class*="IconWrapper-"] {
                            width: 40px;
                            height: 40px;
                        }
                        svg {
                            width: 24px;
                            height: 24px;
                            color: ${colorPallete.primaryRed500};
                        }
                    }
                }

                [data-test-selector="productSelector"] {
                    .dynamicDropdownCustom {
                        border-radius: 28px!important;
                        [data-test-selector="productSelector_search-selectedText"] {
                            padding:6px 10px 6px 50px;
                        }
                    }
                }
                [data-test-selector="productSelector_search-input"] {
                    border:none!important;
                }

                [data-test-selector="productSelector_search-selectedText"] {
                    padding:6px 48px 6px;
                    overflow:hidden;
                    align-items:center;
                    
                }
                [class*="FormFieldStyle"] {
                    & + [class*="gqvGQs"] {
                        left:auto;
                        right:20px;
                    }
                }
            }

            //Wishtlist end

            [class*="SortSelectWrapper"] {
                min-width: 179px;
                .sortButton {
                    position: relative;
                    display: flex;
                    align-items: center;
                    background: ${colorPallete.white};
                    border: 1px solid ${colorPallete.grey300};
                    padding: 8px 10px 8px 16px;
                    border-radius: 8px;
                    font: ${bodyFonts.body2RegularLg.fontWeight} ${bodyFonts.body2RegularLg.fontSize} /
                        ${bodyFonts.body2RegularLg.lineHeight} ${bodyFonts.body2RegularLg.fontFamily};
                    width: 100%;
                    min-height: 40px;
                    &,
                    > span {
                        color: ${colorPallete.grey800};
                    }

                    .selected-sort-option {
                        padding-right: 24px;
                    }

                    [class*="IconWrapper-"] {
                        position: absolute;
                        right: 10px;
                    }

                    &.selected {
                        [class*="IconWrapper-"] {
                            transform: rotate(180deg);
                        }
                    }
                }
            }

            //Order History

            .filter-icon {
                color: ${colorPallete.primaryRed500};
                font-size: ${bodyFonts.body2SemiBoldLg.fontSize};
                font-weight: ${bodyFonts.body2SemiBoldLg.fontWeight};
                cursor: pointer;
                display: flex;
                [class*="IconWrapper"] {
                    margin-left: 8px;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                font-size: 14px;
                            `,
                        ],
                        "max",
                    )}
            }

            //Order History End

            .tableWrapper {
                overflow: auto;
                border: 1px solid ${colorPallete.grey300};
                border-radius: 8px;
                table {
                    position: relative;
                }
                ::-webkit-scrollbar {
                    width: 6px;
                    height:6px;
                }
                ::-webkit-scrollbar-track {
                    box-shadow: inset 0 0 3px ${colorPallete.grey400}; 
                    border-radius: 6px;
                }
                ::-webkit-scrollbar-thumb {
                    background: ${colorPallete.grey800}; 
                    border-radius: 6px;
                    cursor:pointer;
                }
                ::-webkit-scrollbar-thumb:hover {
                    background: ${colorPallete.grey200}; 
                }
            }
            .modalWithInnerScroll {
                > [class*="ContentBody"] {
                    padding: 16px 8px 16px 16px;
                    > div {
                        overflow-y: auto;
                        ::-webkit-scrollbar {
                            width: 6px;
                            height:6px;
                        }
                        ::-webkit-scrollbar-track {
                            box-shadow: inset 0 0 3px ${colorPallete.grey200}; 
                            border-radius: 6px;
                            background: ${colorPallete.grey200}; 
                        }
                        ::-webkit-scrollbar-thumb {
                            background: ${colorPallete.grey800}; 
                            border-radius: 6px;
                            cursor:pointer;
                        }
                        ::-webkit-scrollbar-thumb:hover {
                            background: ${colorPallete.grey200}; 
                        }
                        [class*="ModalTitle"],
                        [class*="ModalContent"] {
                            padding-left: 0;
                            padding-right: 16px;
                        }
                        [class*="ModalTitle"] {
                            padding-top: 0;
                        }
                        [class*="ModalContent"] {
                            padding-bottom: 0;
                        }
                    }
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                padding: 24px 8px 24px 24px;
                                > div {
                                    [class*="ModalTitle"],
                                    [class*="ModalContent"] {
                                        padding-right: 24px;
                                    }
                                }
                            `,
                        ],
                        "min",
                    )}
                }
            }

            [data-test-selector="productSelector"] {
                .dynamicDropdownCustom {
                    [data-test-selector="productSelector_search-selectedText"] {
                        top: 14px;
                        width: calc(100% - 32px);
                        padding-top: 0 !important;
                        padding-bottom: 0 !important;
                    }
                }
            }

            //Switch

            [data-test-selector="invoiceHistory_showOpenInvoicesFilter"] {
                [class*="IconWrapper"] {
                    display: none !important;
                }
                &.checkboxChecked {
                    .switch {
                        position: relative;
                        background: ${colorPallete.primaryRed500};
                        &:before {
                            background: ${colorPallete.white};
                            transform: translateX(24px);
                            content: "";
                        }
                        &:after {
                            content: "";
                            display: inline-block;
                            transform: rotate(45deg);
                            height: 11px;
                            width: 6px;
                            border-bottom: 2px solid ${colorPallete.primaryRed500};
                            border-right: 2px solid ${colorPallete.primaryRed500};
                            position: absolute;
                            top: 5px;
                            left: 33px;
                        }
                    }
                }
            }

            //Order Confirmation Start

            [data-test-selector="page_OnePageCheckoutConfirmationPage"] {
                [class*="GridWrapper"] {
                    [class*="GridOffset"] {
                        [class*="GridItemStyle"]:first-child {
                            [class*="Wrapper"]:empty {
                                display: none;
                            }
                        }
                    }
                }
                .cart-line-container {
                    padding: 24px 0;
                    &:first-child {
                        padding-top: 8px;
                    }
                    &:last-child {
                        margin-bottom: 24px;
                    }
                }
            }
            .order-confimation-list {
                &.boxGrey {
                    padding: 0;
                    background: ${colorPallete.white};
                    border: none;
                    margin-top: 36px;
                    [data-test-selector="sectionHeader"] {
                        border-bottom: 1px solid ${colorPallete.grey400};
                        div {
                            width: 100%;
                            border: none;
                        }
                    }
                    button {
                        cursor: default;
                    }
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                margin-top: 48px;
                                [data-test-selector="sectionHeader"] {
                                    border: none;
                                }
                            `,
                        ],
                        "min",
                    )}
                }
            }
            //Order History End

            //My Account Start
            .fulfillment-address {
                gap: 16px;
                .address-title {
                    font-size: ${bodyFonts.body1SemiBoldLg.fontSize};
                    font-weight: ${bodyFonts.body1SemiBoldLg.fontWeight};
                    margin-bottom: 15px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    font-size: 16px;
                                `,
                            ],
                            "max",
                        )}
                    [class*="IconWrapper"] {
                        display: block;
                        margin-bottom: 15px;
                        width: 40px;
                        height: 40px;
                        svg {
                            width: 40px;
                            height: 40px;
                        }
                    }
                }
                [class*="GridOffset"] {
                    margin: 0;
                    width: 100% !important;
                    gap: 16px;
                    flex-wrap: nowrap !important;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    flex-direction: column;
                                `,
                            ],
                            "max",
                        )}
                }
                [class*="GridItemStyle"] {
                    border: 1px solid ${colorPallete.grey500};
                    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
                    border-radius: 8px;
                    display: flex;
                    padding: 24px 20px;
                    flex-direction: column;
                    align-items: flex-start;
                    p {
                        font-size: 14px;
                    }
                    address {
                        display: flex;
                        flex-direction: column;
                        height: 100%;
                    }
                    [class*="StyledClickable"] {
                        margin-top: 24px;
                        span {
                            font-size: 14px;
                            font-weight: 600;
                            color: ${colorPallete.primaryRed500};
                            text-decoration: underline;
                            display: inline-block;
                        }
                        &:hover {
                            span {
                                color: ${colorPallete.primaryMaroon500};
                            }
                        }
                    }
                    .btn-secondary {
                        span {
                            text-decoration: none;
                        }
                        &:hover {
                            span {
                                color: ${colorPallete.white};
                            }
                        }
                    }
                }
            }
            
            [data-test-selector="page_MyAccountPage"] {
                .card_container__wrapper {
                    border-bottom: 1px solid ${colorPallete.grey300};
                    width: 100%;
                    &:last-child {
                        border-bottom: none;
                    }
                    & > [class*="GridItemStyle"] {
                        padding: 16px 24px !important;
                        [class*="GridItemStyle"] {
                            padding: 0;
                            font-size: 14px;
                            [class*="StyledButton"] {
                                text-decoration: underline;
                            }
                        }
                    }
                    .order-summary-card-container {
                        [class*="GridOffset"] {
                            padding: 0;
                            margin: 0;
                            width: 100% !important;
                        }
                    }
                }
                [data-test-selector="widget_RecentOrders"] {
                    [class*="GridOffset"] {
                        padding: 0;
                        margin: 0;
                        width: auto;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    null,
                                    css`
                                        max-width: 1000px;
                                    `,
                                ],
                                "max",
                            )}
                    }
                }
                [data-test-selector="myAccountMessagesSection"] {
                    border: 1px solid ${colorPallete.grey500};
                    border-radius: 8px;
                    padding: 16px 24px;
                    margin-bottom: 25px;
                    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    margin-bottom: 9px;
                                `,
                            ],
                            "max",
                        )}
                    [data-test-selector="sectionHeader"] {
                        button {
                            border: none;
                            background: none;
                            padding: 0;
                        }
                    }
                    [data-test-selector="sectionPanel"] {
                        border: none;
                        background: none;
                    }
                }
                [data-test-selector="PageTitle"] {
                    font-size: ${headlineFonts.headline1SemiBoldLg.fontSize};
                    font-weight: ${headlineFonts.headline1SemiBoldLg.fontWeight};
                    line-height: ${headlineFonts.headline1SemiBoldLg.lineHeight};
                    margin-bottom: 20px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    font-size: ${headlineFonts.headline1SemiBoldSm.fontSize};
                                    line-height: ${headlineFonts.headline1SemiBoldSm.lineHeight};
                                `,
                            ],
                            "max",
                        )}
                }
                .quick-links {
                    h2 {
                        font-size: 16px;
                        font-weight: 600;
                    }
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    display: none;
                                `,
                            ],
                            "max",
                        )}
                }

                [class*="DataTableStyle"] {
                    thead {
                        border: 1px solid ${colorPallete.grey300};
                        border-radius: 8px;
                        padding: 16px 24px !important;
                        background: ${colorPallete.grey50};
                    }
                    th {
                        background: none;
                        border: none;
                    }
                }
                [data-test-selector="myAccountMessagesSection"] {
                    [class*="GridOffset"] {
                        margin: 0;
                        width: auto;
                        [class*="GridItemStyle"] {
                            padding: 0;
                        }
                    }
                    [class*="AccordionSectionPanel"] {
                        padding: 0;
                    }
                }

                [class*="AccordionStyle"] {
                    display: flex;
                    flex-direction: column;
                    gap: 15px;
                    position: relative;
                    [class*="IconWrapper"] {
                        position: absolute;
                        top: -5px;
                    }
                    .msg-count {
                        color: ${colorPallete.primaryRed500};
                    }
                    [data-test-selector="sectionHeader"] {
                        display: flex;
                        flex-direction: row;
                        button {
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            padding: 0 0 0 55px !important;
                            background:none;
                            border:none;

                            &, & span {
                                font-size: ${bodyFonts.body2SemiBoldLg.fontSize};
                                line-height: ${bodyFonts.body2SemiBoldLg.lineHeight};
                            }
                            ${({ theme }: { theme: BaseTheme }) =>
                                breakpointMediaQueries(
                                    theme,
                                    [
                                        null,
                                        null,
                                        css`
                                            font-size: 16px;
                                        `,
                                    ],
                                    "max",
                                )}
                        }
                        [class*="IconPositioner"] {
                            [class*="IconWrapper"] {
                                position: relative;
                                top: 3px;
                            }
                        }
                    }
                }

                [data-test-selector="orderSummaryCard_header"],
                [data-test-selector="userDetail_header"] {
                    border: 1px solid ${colorPallete.grey300};
                    border-radius: 8px;
                    padding: 16px 24px !important;
                    background: ${colorPallete.grey50};
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    padding: 16px !important;
                                `,
                            ],
                            "max",
                        )}
                    [class*="GridItemStyle"] {
                        padding: 0;
                        font-size: 14px;
                        font-weight: 600;
                        text-transform:capitalize;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    null,
                                    css`
                                        font-size: 12px;
                                    `,
                                ],
                                "max",
                            )}
                    }
                }
            }

            .quick-links-container {
                [class*="Wrapper"] {
                    margin: 0 24px 0 20px !important;
                    border: none !important;
                }
                > [class*="IconWrapper"] {
                    top: 0 !important;
                }
                border: none !important;
                [data-test-selector="sectionHeader"] {
                    display: none !important;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    display: block !important;
                                    background: none !important;
                                    border: none !important;
                                    padding: 0;
                                    .button-Quick {
                                        padding: 0 !important;
                                        background: none !important;
                                        border: none !important;
                                    }
                                `,
                            ],
                            "max",
                        )}
                }
                [data-test-selector="sectionPanel"] {
                    padding: 0;
                    border: none !important;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    border-top: 1px solid ${colorPallete.grey500}!important;
                                `,
                            ],
                            "max",
                        )}
                }
            }

            //My Account End

            //  Select Branch any where

            [data-test-selector="findLocationModal"] {
                [class*="GridOffset"] {
                    margin:0!important;
                    width:auto!important;
                }
            }

            [data-test-selector="page_QuickOrderPage"] {
                [data-test-selector="priceIncludeVat"] {
                    display: flex;
                    align-items: center;
                }
                [data-test-selector="productPrice_unitNetPrice"] {
                    align-items: center;
                    display: flex;
                    color: ${colorPallete.grey800};
                    .price {
                        font: ${headlineFonts.headline3SemiBoldSm.fontWeight}
                            ${headlineFonts.headline3SemiBoldSm.fontSize}
                            ${headlineFonts.headline3SemiBoldSm.lineHeight}
                            ${headlineFonts.headline3SemiBoldSm.fontFamily};
                    }
                    .uom {
                        font: ${bodyFonts.body2RegularSm.fontWeight} ${bodyFonts.body2RegularSm.fontSize}
                            ${bodyFonts.body2RegularSm.lineHeight} ${bodyFonts.body2RegularSm.fontFamily};
                    }
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            [data-test-selector="page_QuickOrderPage"] {
                                [data-test-selector="productPrice_unitNetPrice"] {
                                    .price {
                                        font-size: ${headlineFonts.headline3SemiBoldLg.fontSize};
                                        line-height: ${headlineFonts.headline3SemiBoldLg.lineHeight};
                                    }
                                }
                            }
                            [class*="PageStyle"] .ship_to_details {
                                margin-bottom: 0;
                            }
                        `,
                    ],
                    "min",
                )}

            .payment-steps-wrapper {
                display: flex;
                align-items: center;
                justify-content: space-between;
                max-width: 1280px;
                margin: 0 auto 24px !important;

                .payment-steps {
                    display: flex;
                    align-items: center;
                    p {
                        margin: 0;
                        font-size: ${bodyFonts.body2SemiBoldLg.fontSize};
                        line-height: ${bodyFonts.body2SemiBoldLg.lineHeight};
                        font-weight: ${bodyFonts.body2SemiBoldLg.fontWeight};

                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    css`
                                        font-size: ${bodyFonts.body2SemiBoldSm.fontSize};
                                        line-height: ${bodyFonts.body2SemiBoldSm.lineHeight};
                                    `,
                                    null,
                                    null,
                                ],
                                "max",
                            )}
                    }

                    .payment-step {
                        display: flex;
                        align-items: center;
                        column-gap: 16px;
                        background: #f6f6f7;
                        border: 1px solid #d0d0d0;
                        padding: 7px 8px;
                        padding-right: 45px;
                        position: relative;

                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    css`
                                        border: none;
                                        padding: 0;
                                        background: none;
                                        gap: 8px;
                                    `,
                                    null,
                                    null,
                                ],
                                "max",
                            )}
                    }

                    .payment-step::after {
                        content: "";
                        position: absolute;
                        width: 34px;
                        height: 34px;
                        background: #f6f6f7;
                        transform: rotate(45deg);
                        right: -18px;
                        border-top: 1px solid #d0d0d0;
                        border-right: 1px solid #d0d0d0;

                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    css`
                                        content: none;
                                    `,
                                    null,
                                    null,
                                ],
                                "max",
                            )}
                    }

                    .step-no {
                        font-size: ${bodyFonts.body1SemiBoldLg.fontSize};
                        line-height: ${bodyFonts.body1SemiBoldLg.lineHeight};
                        font-weight: ${bodyFonts.body1SemiBoldLg.fontWeight};
                        background: ${colorPallete.white};
                        width: 32px;
                        height: 32px;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    css`
                                        width: auto;
                                        height: auto;
                                        background: none;
                                        position: relative;
                                        font-size: ${bodyFonts.body1SemiBoldSm.fontSize};
                                        line-height: ${bodyFonts.body1SemiBoldSm.lineHeight};

                                        &::after {
                                            content: ".";
                                        }
                                    `,
                                    null,
                                    null,
                                ],
                                "max",
                            )}
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    null,
                                    css`
                                        color: ${colorPallete.grey800};
                                    `,
                                ],
                                "min",
                            )}
                    }

                    .step-2 {
                        padding-left: 42px;
                        color: ${colorPallete.grey500};

                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    css`
                                        padding-left: 8px;
                                    `,
                                    null,
                                    null,
                                ],
                                "max",
                            )}
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    null,
                                    css`
                                        color: ${colorPallete.grey600DisabledText};
                                    `,
                                ],
                                "min",
                            )}
                    }

                    .active {
                        background: ${colorPallete.grey800};
                        color: ${colorPallete.white};
                        border-top-left-radius: 40px;
                        border-bottom-left-radius: 40px;
                        position: relative;

                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    css`
                                        color: ${colorPallete.grey800};
                                        background: ${colorPallete.white};
                                        border-top-left-radius: 0;
                                        border-bottom-left-radius: 0;
                                    `,
                                    null,
                                    null,
                                ],
                                "max",
                            )}
                    }

                    .active::after {
                        background: ${colorPallete.grey800};
                        z-index: 1;
                    }
                }

                .secure-checkout {
                    display: flex;
                    align-items: center;
                    column-gap: 8px;
                    p {
                        margin: 0;
                        font-size: ${buttonFonts.buttonLg.fontSize};
                        line-height: ${buttonFonts.buttonLg.lineHeight};
                        font-weight: ${buttonFonts.buttonLg.fontWeight};

                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    css`
                                        display: none;
                                    `,
                                    null,
                                    null,
                                ],
                                "max",
                            )}
                    }
                }
            }

            .failedToLoad {
                border:1px solid ${colorPallete.grey300};
                border-radius:8px;
                padding:16px;
                align-items:center;
                display:flex;
                flex-direction:row!important;
                white-space:normal;
                [class*="TypographyStyle"] {
                    color:${colorPallete.primaryRed500};
                    font-size:16px;
                    font-weight:600;
                    margin:0 0 0 15px;
                    text-align:left;
                }
            }
            [aria-labelledby="drawerTitle"] {
                transition: none;
                box-shadow: none;
            }
        
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            body {
                                &[class*="popoverOpen-headerSearch-"] {
                                    overflow: hidden;
                                }
                            }
                        }
                    `,
                    ],
                    "max",
                )}

            @media screen and (min-width:1023px) and (max-width:1024px) {
                .mobile-menu-wrapper {
                    display: none;
                }
            }

            @media screen and (min-width: 767px) and (max-width: 1023px) {
                .hidden-cart-count-wrapper {
                    display: block !important;
                }
            }

            @media only screen and (min-width: 1024px) {
                .spotlight-description {
                    padding: 0 24px;
                    flex: 0 1 830px;
                }
            }
            [data-test-selector="page_ProductListPage"] main {
                padding: 24px 24px 80px;
                [data-test-selector="pageBreadcrumbs"] {
                    padding-top: 0;
                }
            }
            [data-test-selector="page_ManageDeliveryAddressesPage"],
            [data-test-selector="page_AccountSettingsPage"],
            [data-test-selector="page_ChangePasswordPage"],
            [data-test-selector="page_OrderDetailsPage"],
            [data-test-selector="page_MyListsDetailsPage"],
            [data-test-selector="page_BrandDetailsPage"],
            [data-test-selector="page_UserSetupPage"],
            [data-test-selector="page_UserListPage"],
            [data-test-selector="page_SavedOrderListPage"],
            [data-test-selector="page_SavedOrderDetailsPage"],
            [data-test-selector="page_InvoiceHistoryPage"],
            [data-test-selector="page_OrderHistoryPage"] {
                [data-test-selector="pageBreadcrumbs"] {
                    padding-left: 0;
                }
            }
            @media only screen and (min-width: 1024px) and (max-width: 1346px) {
                [data-test-selector="page_BrandDetailsPage"] [data-test-selector="pageBreadcrumbs"] {
                    padding-top: 24px;
                }
            }
         

            @media screen and (max-width: 1023px) {
                [data-test-selector="page_ProductListPage"] main {
                    padding: 24px 16px 24px;
                }
            }
            @media screen and (min-width: 1346px) {
                [data-test-selector="page_ProductListPage"] main,
                [data-test-selector="page_BrandDetailsPage"] main {
                    padding: 24px 80px 80px;
                    .product-expanded-grid-carousel {
                        width: calc(100% + 160px);
                        margin: 0px -80px;
                    }
                }
                [data-test-selector="page_ManageDeliveryAddressesPage"],
                
                [data-test-selector="page_InvoiceDetailsPage"],
                [data-test-selector="page_RequestLoginConfirmationPage"],
                [data-test-selector="page_OrderDetailsPage"],
                [data-test-selector="page_StaticListPage"],
                [data-test-selector="page_OnePageCheckoutConfirmationPage"],
                [data-test-selector="page_AccountSettingsPage"],
                [data-test-selector="page_MyAccountPage"],
                [data-test-selector="page_UserSetupPage"],
                [data-test-selector="page_UserListPage"],
                [data-test-selector="page_SavedOrderListPage"],
                [data-test-selector="page_SavedOrderDetailsPage"],
                [data-test-selector="page_OrderHistoryPage"],
                [data-test-selector="page_InvoiceHistoryPage"] {
                    main {
                        padding-left: 80px;
                        padding-right: 80px;
                    }
                }   
            }

            @media only screen and (min-width: 1367px) {
                [data-test-selector="page_CategoryDetailsPage"] main {
                    padding: 24px 40px 40px;
                }
            }

            @media only screen and (min-width: 1440px) {
                [data-test-selector="page_CategoryDetailsPage"] main {
                    padding: 24px 80px 80px;
                }
            }
            @media screen and (min-width: 1400px) { 
                [data-test-selector="page_MyListsPage"] {
                    main {
                        padding-left: 80px;
                        padding-right: 80px;
                    }
                }
            }
            [data-test-selector="page_BrandsPage"] {
                [data-test-selector="PageTitle"] {
                    max-width: 1280px;
                    margin-left: auto;
                    margin-right: auto;
                }
            }
            @media screen and (min-width: 768px) {
                [data-test-selector="page_BrandDetailsPage"],
                [data-test-selector="page_ProductListPage"] {
                    [data-test-selector="productListCards_Grid"] {
                        [data-test-selector="productImage"] {
                            display: block;
                            min-height: 138px;
                            max-height: 138px;
                            text-align: center;
                            img {
                                min-height: 138px;
                                object-fit: contain;
                                max-height: 138px;
                            }
                        }
                        .priceWrapper,
                        .productAvailability {
                            height: auto;
                        }
                        .priceWrapper {
                            min-height: 95px;
                        }
                        .productAvailability {
                            min-height: initial;
                            margin-bottom: auto;
                            padding-bottom: 16px;
                            height: 100%;
                        }
                        .brandInProductCard {
                            min-height: 31px;
                        }
                        .signInWrapperPrice + .product-actions-wrapper {
                            display: none;
                        }
                        .partNumber {
                            min-height: 80px;
                        }
                    }
                }
            }
            
            .dsgPlusButtonSection {
                padding: 20px 0;
            }
            [data-test-selector="page_DsgCustomPage"] {
                main {
                    > div {
                        max-width: 1280px;
                    }
                    .dsgPlusTwoColumn {
                        .wrapper {
                            li {
                                color: ${colorPallete.grey800};
                            }
                        }
                    }
                    h1 {
                        color: ${colorPallete.grey800};
                    }
                }
            }
            .dsgPlusTwoColumn {
                > div > div {
                    &:last-child {
                        h3 {
                            margin-bottom: 40px;
                        }
                    }
                    &:first-child {
                        h3 {
                            margin: 20px 0;
                        }
                    }
                }
                h3 {
                    font: ${headlineFonts.headline3SemiBoldSm.fontWeight} ${headlineFonts.headline3SemiBoldSm.fontSize} /
                        ${headlineFonts.headline3SemiBoldSm.lineHeight} ${headlineFonts.headline3SemiBoldSm.fontFamily};
                    color: ${colorPallete.grey800};
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            .dsgPlusTwoColumn {
                                > div > div {
                                    &:first-child {
                                        padding-right: 10px;
                                    }
                                    &:last-child {
                                        padding-left: 10px;
                                    }
                                }
                                h3 {
                                    font: ${headlineFonts.headline3SemiBoldLg.fontWeight}
                                        ${headlineFonts.headline3SemiBoldLg.fontSize} /
                                        ${headlineFonts.headline3SemiBoldLg.lineHeight}
                                        ${headlineFonts.headline3SemiBoldLg.fontFamily};
                                }
                            }
                            [data-test-selector="page_DsgCustomPage"] {
                                main {
                                    h1 {
                                        font-size: ${headlineFonts.headline2SemiBoldLg.fontSize};
                                        line-height: ${headlineFonts.headline2SemiBoldLg.lineHeight};
                                    }
                                }
                            }
                        `,
                    ],
                    "min",
                )}

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            .dsgPlusTwoColumn {
                                > div {
                                    row-gap: 40px;
                                }
                            }
                            [data-test-selector="page_NewsPage"] {
                                .fr-video iframe {
                                    width: 350px !important;
                                }
                            }
                        `,
                    ],
                    "max",
                )}
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            .dsgPlusTwoColumn {
                                > div {
                                    flex-direction: row !important;
                                    > div {
                                        &:first-child {
                                            max-width: 55% !important;
                                            flex-basis: 55% !important;
                                        }
                                        &:last-child {
                                            max-width: 45% !important;
                                            flex-basis: 45% !important;
                                        }
                                    }
                                }
                            }
                        `,
                    ],
                    "minMax",
                )}

            .industries-header-row {
                > [class*="GridOffset"] {
                    column-gap: 16px;

                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        css`
                            row-gap: 8px;
                        `,
                        null,
                    ], "max")}

                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        css`
                            flex-wrap: nowrap;
                        `,
                        null,
                    ], "min")}

                    .industries-header-content {
                        &, > [class*="ContentWrapper"] {
                            height: 100%;
                        }
                    }

                    > div[class*="GridItem"] {
                        border-radius: 8px;

                        flex-basis: calc(50% - 8px);
                        max-width: calc(50% - 8px);

                        > [class*="Wrapper"] {
                            height: 100%;
                        }

                        [class*="LazyImageStyle"] {
                            padding-bottom: 24px;

                            ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                null,
                                null,
                                css`
                                    padding-bottom: 0;
                                `,
                                null,
                            ], "max")}
                        }

                        &:last-child {
                            > [class*="Wrapper"] {
                                height: 100%;
                                > div {
                                    height: 100%;
                                }
                            }
                            .img-wrapper {
                                width: 100%;
                                height: 100%;
                                padding-bottom: 0;
                                img {
                                    border-radius: 8px;
                                    width: 100%;
                                    height: 100%;
                                    display: block;
                                    object-fit: cover;
                                }
                            }
                        }

                        [class*="ContentWrapper"] {
                            border-radius: 8px;
                            h1, h1 strong {
                                font-size: ${headlineFonts.headline1SemiBoldLg.fontSize};
                                line-height: ${headlineFonts.headline1SemiBoldLg.lineHeight};
                                font-weight: ${headlineFonts.headline1SemiBoldLg.fontWeight};
                                color: ${colorPallete.white};
                            }

                            h1,
                            h2,
                            h3,
                            h4,
                            h5,
                            h6 {
                                color: ${colorPallete.white};
                            }

                            ${({ theme }: { theme: BaseTheme }) =>
                                breakpointMediaQueries(theme, [
                                    null,
                                    css`
                                        padding: 16px;
                                        h1, h1 strong {
                                            font-size: ${headlineFonts.headline1SemiBoldSm.fontSize};
                                            line-height: ${headlineFonts.headline1SemiBoldSm.lineHeight};
                                        }
                                    `,
                                    null,
                                    null,
                                ], "max")}  

                            p:has(img) {
                                margin-bottom: 0;
                            }
                        }
                    }
                }

                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    css`
                        .industries-header-content {
                            [class*="ContentWrapper"] {
                                img {
                                    max-width: 48px;
                                }
                            }
                        }
                    `,
                    null,
                    null,
                ], "max")}
            }


            .industries-page-section {
                max-width: 1280px !important;
                margin: 0 auto !important
            }

            .industries-description-row {
                color: ${colorPallete.white};
                border-radius: 8px;
                padding: 40px;
                margin-top: 16px !important;

                h3 {
                    font-weight: ${themeFontWeights.semiBold};
                }
                
                [class*="TypographyStyle"] {
                    color: ${colorPallete.white};
                }
                .industries-description-title {
                    h1, h2, h3, h4, [class*="TypographyStyle"] {
                        font: ${headlineFonts.headline2SemiBoldLg.fontWeight} ${headlineFonts.headline2SemiBoldLg.fontSize}/${headlineFonts.headline2SemiBoldLg.lineHeight} ${headlineFonts.headline2SemiBoldLg.fontFamily};

                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                null,
                                css`
                                    font: ${headlineFonts.headline2SemiBoldSm.fontWeight} ${headlineFonts.headline2SemiBoldSm.fontSize}/${headlineFonts.headline2SemiBoldSm.lineHeight} ${headlineFonts.headline2SemiBoldSm.fontFamily};
                                `,
                                null,
                                null,
                            ], "max")}
                    }
                }
                .industries-description-text {
                    p {
                        font-size: ${bodyFonts.body1RegularSm.fontSize};
                        line-height: ${bodyFonts.body1RegularSm.lineHeight};
                    }
                }

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        css`
                            padding: 24px;
                            h3 {
                                font-size: ${headlineFonts.headline3SemiBoldSm.fontSize};
                                line-height: ${headlineFonts.headline3SemiBoldSm.lineHeight};
                            }

                            .industries-description-title {
                                h4 {
                                    font-size: ${headlineFonts.headline3SemiBoldSm.fontSize};
                                    line-height: ${headlineFonts.headline3SemiBoldSm.lineHeight};
                                }
                            }
                            > div {
                                > div {
                                    &:first-child {
                                        padding-bottom: 0;
                                    }
                                    &:last-child {
                                        padding-top: 0;
                                    }
                                }
                            }
                        `,
                        null,
                        css`
                            > [class*="GridOffset"] {
                                row-gap: 24px;
                            }
                        `,
                    ], "max")}
            }

            .industries-professional-services-content {
                max-width: 1280px;
                margin: 0 auto;
                padding: 48px 0;
                border-bottom: 1px solid ${colorPallete.grey500};

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        css`
                            padding: 40px 24px;
                        `,
                        null,
                        null,
                    ], "max")}

                h3 {
                    font-size: ${headlineFonts.headline2SemiBoldLg.fontSize};
                    line-height: ${headlineFonts.headline2SemiBoldLg.lineHeight};
                    font-weight: ${headlineFonts.headline2SemiBoldLg.fontWeight};
                    margin-bottom: 40px;
                    text-align: center;

                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        css`
                            font-size: ${headlineFonts.headline3SemiBoldSm.fontSize};
                            line-height: ${headlineFonts.headline3SemiBoldSm.lineHeight};
                            margin-bottom: 24px;
                            text-align: left;
                        `,
                        null,
                        null,
                    ], "max")}
                }

                [class*="UnorderedListStyle"] {
                    margin-left: 0 !important;
                    list-style: none;
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    grid-template-rows: minMax(auto, 1fr);
                    grid-row-gap: 24px;
                    justify-content: center;
                    grid-column-gap: 48px;
                    margin-bottom: 0 !important;
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        css`
                            grid-template-columns: 1fr;
                            grid-row-gap: 16px;
                        `,
                        null,
                        null,
                    ], "max")}

                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        null,
                        css`
                            padding: 0 109px !important;
                        `,
                    ], "min")}

                    li {
                        font-size: ${buttonFonts.buttonLg.fontSize};
                        line-height: ${buttonFonts.buttonLg.lineHeight};
                        font-weight: ${buttonFonts.buttonLg.fontWeight};
                        position: relative;

                        ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            null,
                            css`
                                font-size: ${buttonFonts.buttonSm.fontSize};
                                line-height: ${buttonFonts.buttonSm.lineHeight};
                            `,
                            null,
                            null,
                        ], "max")}

                        a {
                            padding-left: 24px;
                            &::before {
                                content: "";
                                position: absolute;
                                background: url("data:image/svg+xml,%3Csvg width='17' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.668 9.5C15.7617 9.5 16.668 10.4062 16.668 11.5V14C16.668 15.125 15.7617 16 14.668 16H2.66797C1.54297 16 0.667969 15.125 0.667969 14V11.5C0.667969 10.4062 1.54297 9.5 2.66797 9.5H4.32422L5.82422 11H2.66797C2.38672 11 2.16797 11.25 2.16797 11.5V14C2.16797 14.2812 2.38672 14.5 2.66797 14.5H14.668C14.918 14.5 15.168 14.2812 15.168 14V11.5C15.168 11.25 14.918 11 14.668 11H11.4805L12.9805 9.5H14.668ZM14.168 12.75C14.168 13.1875 13.8242 13.5 13.418 13.5C12.9805 13.5 12.668 13.1875 12.668 12.75C12.668 12.3438 12.9805 12 13.418 12C13.8242 12 14.168 12.3438 14.168 12.75ZM8.13672 11.5312L3.85547 7.28125C3.54297 7 3.54297 6.53125 3.85547 6.21875C4.13672 5.9375 4.60547 5.9375 4.91797 6.21875L7.91797 9.21875V0.75C7.91797 0.34375 8.23047 0 8.66797 0C9.07422 0 9.41797 0.34375 9.41797 0.75V9.21875L12.3867 6.25C12.668 5.9375 13.1367 5.9375 13.418 6.25C13.7305 6.53125 13.7305 7 13.418 7.28125L9.16797 11.5312C9.04297 11.6875 8.85547 11.75 8.66797 11.75C8.44922 11.75 8.26172 11.6875 8.13672 11.5312Z' fill='%23C91E24'/%3E%3C/svg%3E")
                                    no-repeat;
                                top: 50%;
                                transform: translateY(-50%);
                                left: 0px;
                                height: 24px;
                                width: 16px;
                            }
                            &:hover {
                                color: ${colorPallete.primaryRed500};
                                [class*="StyledTypography"] {
                                    color: ${colorPallete.primaryRed500};
                                }
                            }
                        }
                    }
                }
            }
            [data-test-selector="orderHistory_showHideFilters"],
            [data-test-selector="invoiceHistory_toggleFilter"] {
                align-items: center;
            }
            .fullfillmentTag {
                display: flex;
                padding: 5px 9px;
                justify-content: center;
                align-items: center;
                gap: 8px;
                border-radius: 4px;
                border: 1px solid ${colorPallete.semanticGreen500};
                background: rgba(204, 251, 231, 0.30);
                color: ${colorPallete.semanticGreen500};
                font: ${labelFonts.label1SemiBold.fontWeight} ${labelFonts.label1SemiBold.fontSize}/${labelFonts.label1SemiBold.lineHeight} ${labelFonts.label1SemiBold.fontFamily};
                svg {
                    width: 16px;
                    height: 16px;
                }
              
            }
            .greyBoxHeading {
                display: flex;
                margin-bottom: 24px;
                width: 100%;
                padding: 7px 16px;
                border-radius: 8px;
                border: 1px solid ${colorPallete.grey500};
                background: ${colorPallete.grey50};
                color: ${colorPallete.grey800};
                font: ${headlineFonts.headline3SemiBoldSm.fontWeight} ${headlineFonts.headline3SemiBoldSm.fontSize}/${headlineFonts.headline3SemiBoldSm.lineHeight} ${headlineFonts.headline3SemiBoldSm.fontFamily};
            }
            .greyBoxHeadingContent {
                padding: 0 16px; 
                width: 100%;
            }
            .twoColumnOrderInfoSection {
                margin-bottom: 24px;
                > div{
                    > div {
                        &:nth-child(even) { 
                            > div:not(:empty) {
                                padding-top: 24px;
                            }
                        }
                        &:nth-child(odd):not(:first-child) { 
                            > div:not(:empty) {
                                padding-top: 40px;
                            }
                        }
                    }
                }
                @media print {
                    > div {
                        > div {
                            &[class*="GridItemStyle"] {
                                margin: 0;
                            }
                            &:nth-child(even) {
                                padding-left: 8px;
                            }
                            &:nth-child(odd) {
                                padding-right: 8px;
                            }
                        }
                    }
                }
            }
            @media print {
                [data-test-selector="page_MyListsDetailsPage"] {
                    main {
                        padding: 0 !important;
                    }
                }
                main {
                    [data-test-selector="pageBreadcrumbs"] {
                        padding: 0;
                    }
                    .greyBoxHeading {
                        margin-bottom: 8px;
                        padding: 0;
                        border-radius: 0;
                        border: none;
                        padding-bottom: 8px;
                        border-bottom: 1px solid ${colorPallete.grey300};
                        background: transparent;
                        h2 {    
                            font-size: ${printFonts.headingLevel1.fontSize};
                            line-height: ${printFonts.headingLevel1.lineHeight};
                        }
                    }

                    .greyBoxHeadingContent {
                        padding: 0; 
                        width: 100%;
                    }
                    .twoColumnOrderInfoSection {
                        margin-bottom: 16px;
                        > div{
                            > div {
                                &:nth-child(even) { 
                                    > div:not(:empty) {
                                        padding-top: 0;
                                    }
                                }
                                &:nth-child(odd):not(:first-child) { 
                                    > div:not(:empty) {
                                        padding-top: 16px;
                                    }
                                }
                            }
                       }
                    }
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                css`
                    .mobileFullWidthIframe {
                        width: 100%;
                    }
                    .cmsMobileFullWidth {
                        width: 100%;
                        max-width: initial !important;
                    }
                `,
                css`
                    .hasPDPStickyHeader {
                        footer {
                            padding-bottom: 129px;
                        }
                    }
                `,
            ], "max")}
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                css`
                    .fullfillmentTag {
                        padding: 7px 11px;
                        font-size: ${bodyFonts.body2SemiBoldLg.fontSize};
                        line-height: ${bodyFonts.body2SemiBoldLg.lineHeight};
                        svg {
                            width: 24px;
                            height: 24px;
                        }
                    }
                    .greyBoxHeading {
                        padding: 15px 24px;
                        font-size: ${headlineFonts.headline3SemiBoldLg.fontSize};
                        line-height: ${headlineFonts.headline3SemiBoldLg.lineHeight};
                    }
                    .greyBoxHeadingContent {
                        padding: 0 24px; 
                    }
                    .twoColumnOrderInfoSection {
                        > div{
                            row-gap: 24px;
                            > div {
                                &:nth-child(even) { 
                                    padding-left: 8px;
                                    > div:not(:empty) {
                                        padding-top: 0;
                                    }
                                }
                                &:nth-child(odd) { 
                                    padding-right: 8px;
                                }
                                &:nth-child(odd):not(:first-child) {  
                                    > div:not(:empty) {
                                        padding-top: 0;
                                    }
                                }
                            }
                        }
                    }
                `,
                css`
                    [data-test-selector="page_CartPage"] {
                        .product-expanded-grid-carousel.product-carousel {
                            margin-top: 0 !important;
                            margin-bottom: 24px !important;
                        }
                    }
                    .twoColumnOrderInfoSection {
                        > div{
                            row-gap: 24px;
                            > div {
                                &:nth-child(even) { 
                                    padding-left: 32px;
                                }
                                &:nth-child(odd) { 
                                    padding-right: 32px;
                                }
                            }
                        }
                    }
                    [data-test-selector="page_ProductDetailsPage"] {
                        .product-expanded-grid-carousel.product-carousel {
                            margin-top: 24px !important;
                            margin-bottom: 24px !important;
                        }
                    }
                `,
            ], "min")}
            @media print {
                .fullfillmentTag {
                    max-width: 150px;
                    padding: 2px 10px;
                    font-size: ${printFonts.bodyRegularSm.fontSize};
                    line-height: ${printFonts.bodyRegularSm.lineHeight};
                }
                [data-test-selector="drawer_CookiePolicy"] {
                    display: none;
                }
            }
            /*Homepage Redesign*/
            .staticCustomerBanner {
                padding-left: 13px;
                padding-right: 13px;
                margin: 24px 0;
                .dsgBtn {
                    padding: 8px 24px;
                    min-height: 48px;
                    font-size: ${buttonFonts.buttonLg.fontSize};
                }
                p, .text-link {
                    font-size: ${bodyFonts.body1SemiBoldLg.fontSize};
                    line-height: ${bodyFonts.body1SemiBoldLg.lineHeight};
                    color: ${colorPallete.grey800};
                }
            }
            .viewShopByButton {
                margin-top: 24px;
                .dsgBtn {
                    padding: 5px 24px;
                    min-height: 48px;
                }
            }

            .trainingWrapper {
                > div {
                    display: flex;
                    justify-content: space-between;
                }
            }
            .trainingBannerImage {
                [class*="LazyImageStyle"] {
                    display: flex !important;
                    padding: 0 !important;
                }
                img {
                    height: 100%;
                    object-fit: cover;
                }
                > div {
                    height: 100%;
                }
            }
            
            .trainingBannerContent {
                padding: 40px;
                display: flex;
                flex-direction: column;
                row-gap: 4px;
                .trainingLabel {
                    font: ${labelFonts.label1SemiBold.fontWeight} ${labelFonts.label1SemiBold.fontSize}/${labelFonts.label1SemiBold.lineHeight} ${labelFonts.label1SemiBold.fontFamily};
                }
                .trainingHeading {
                    font: ${headlineFonts.headline3SemiBoldLg.fontWeight} ${headlineFonts.headline3SemiBoldLg.fontSize}/${headlineFonts.headline3SemiBoldLg.lineHeight} ${headlineFonts.headline3SemiBoldLg.fontFamily};
                }
                .trainingSubText {
                    font: ${bodyFonts.body1RegularLg.fontWeight} ${bodyFonts.body1RegularLg.fontSize}/${bodyFonts.body1RegularLg.lineHeight} ${bodyFonts.body1RegularLg.fontFamily};
                }
                > [class*="TypographyStyle"] {
                    color: ${colorPallete.white};
                    margin: 0;
                }
                .trainingBtnWrapper {
                    margin: 16px 0 0 !important;
                }
            }

            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                css`
                    .fullWidthWrapper {
                        margin-left: -24px !important;
                        margin-right: -24px !important;
                        max-width: calc(100% + 48px);
                        width: calc(100% + 48px);
                    }
                `,
                css`
                    .staticCustomerBanner {
                        padding-left: 66px;
                        padding-right: 66px;
                    }
                    .trainingBannerContent {
                        padding: 24px 50px;
                        width: calc(100% - 364px);
                    }
                    .trainingWrapper {
                        > div {
                            flex-direction: row;
                        }
                        &.desktopImageLeft {
                            > div {
                                flex-direction: row-reverse;
                                justify-content: flex-end;
                            }
                        }
                    }
                    .trainingBannerImage {
                        width: 364px;
                        [class*="LazyImageStyle"] {
                            border-radius: 8px;
                        }
                    }
                `,
            ], "min")}
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                css`
                    .staticCustomerBanner {
                        p .text-link {
                            display: block;
                            margin-top: 20px;
                        }
                    }
                `,
            ], "max")}
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                css`
                    .trainingWrapper {
                        > div {
                            flex-direction: column;
                        }
                        &.mobileImageTop {
                            > div {
                                flex-direction: column-reverse;
                            }
                        }
                        .trainingBannerContent {
                            .trainingSubText {
                                margin-top: 12px;
                            }
                        }
                        .trainingBtnWrapper {
                            margin: 20px 0 0 !important;
                        }
                    }
                    .trainingBannerRow {
                        border-radius: 0 !important;
                    }
                `,
            ], "max")}
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                css`
                    .trainingWrapper {
                        .trainingBannerContent {
                            width: 50%;
                        }
                        .trainingBannerImage {
                            width: 50%;
                        }
                    }
                `,
            ], "minMax")}
            .trainingBannerRow {
                max-width: 1280px;
            }

            .background-disable {
                position: relative;
                overflow: hidden;
                height: auto;
                &::before {
                    content: "";
                    display: block;
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    background: ${colorPallete.black};
                    opacity: 30%;
                    z-index: 999;
                }
            }
            [data-test-selector="page_UserSetupPage"] {
                main {
                    span[role="checkbox"] {
                        background: ${colorPallete.white};
                    }
                    [data-test-selector="PageTitle"] {
                        margin-bottom: 24px;
                    }
                }
            }
            /* Homepage Why DSG Section */
            .why-choose-dsg-section {
                margin: 24px 0;
            }
            .whydsg-wrapper {
                margin: 24px auto !important;
                background: #F0F0F1;
                padding: 48px 16px;
                border-radius: 8px;
                display: flex;
                flex-direction: column;
                align-items: center;

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        css`
                            padding: 40px 16px;
                        `,
                        null,
                    ], "max")}

                }

                .whydsg-grid {
                    display: flex;
                    flex-wrap: nowrap;
                    justify-content: center;
                    gap: 16px;
                    margin-bottom: 48px;
                    max-width: 1280px;

                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        css`
                            margin-bottom: 40px;

                        `,
                        css`
                            flex-wrap: wrap;
                            .whydsg-grid-item {
                                min-height: 358px;
                            }

                        `,
                        null,
                    ], "max")}

                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        null,
                        css`    
                            width: 100%;
                            .whydsg-grid-item {
                                width: calc(100%/3);
                            }
                        `,
                    ], "min")}
                }

                .whydsg-wrapper-title {
                    font-size: ${headlineFonts.headline2SemiBoldLg.fontSize};
                    line-height: ${headlineFonts.headline2SemiBoldLg.lineHeight};
                    font-weight: ${headlineFonts.headline2SemiBoldLg.fontWeight};
                    text-align: center;
                    margin: 0;
                }

                .whydsg-wrapper-title + p {
                    font-size: ${bodyFonts.body1RegularLg.fontSize};
                    line-height: ${bodyFonts.body1RegularLg.lineHeight};
                    font-weight: ${bodyFonts.body1RegularLg.fontWeight};
                    text-align: center;
                    margin-bottom: 40px;
                    margin-top: 24px;

                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        css`
                            margin-bottom: 24px;
                            margin-top: 16px;

                        `,
                        null,
                        null,
                    ], "max")}
                }

                .whydsg-grid-item {
                    position: relative;
                    border-radius: 8px;

                    img {
                        border-radius: 8px;
                        width: 100%;
                        max-width: 416px;
                        height: 100%;
                        object-fit: cover;
                    }
                
                    .whydsg-grid-title {
                        font-size: ${headlineFonts.headline3SemiBoldLg.fontSize};
                        line-height: ${headlineFonts.headline3SemiBoldLg.lineHeight};
                        font-weight: ${headlineFonts.headline3SemiBoldLg.fontWeight};
                        margin: 0;
                        position: absolute;
                        top: 35px;
                        left: 50%;
                        transform: translateX(-50%);
                        width: calc(100% - 20px);
                        text-align: center;
                        color: ${colorPallete.white};

                        ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            null,
                            css`
                               font-size: ${headlineFonts.headline3SemiBoldSm.fontSize};
                               line-height: ${headlineFonts.headline3SemiBoldSm.lineHeight};

                            `,
                            null,
                            null,
                        ], "max")}
                    }
                   
                }

            /* Headquarter banner */
            .headquarter-banner-wrapper {
                display: flex;
                margin: 24px 0 !important;

                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    css`
                        flex-direction: column;
                    `,
                    null,
                    null,
                ], "max")}
            }

            .hq-image {
                [class*="LazyImageStyle"] {
                    display: block !important;
                    padding: 0 !important
                }
            }

            .hq-image img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }

            .hq-image,
            .hq-banner-content {
                flex-basis: 50%;
                max-width: 50%;

                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    null,
                    null,
                ], "max")}
            }

            .hq-banner-content {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: center;
                padding: 48px 80px;
                background-color: ${colorPallete.primaryRed500};
                color:  ${colorPallete.white};

                h2 {
                    margin-bottom: 16px;

                    & + .hq-banner-description {
                        margin-bottom: 40px;
                    }
                }

                .hq-banner-title {
                    font-size: ${headlineFonts.headline2SemiBoldLg.fontSize};
                    line-height: ${headlineFonts.headline2SemiBoldLg.lineHeight};
                    font-weight: ${headlineFonts.headline2SemiBoldLg.fontWeight};
                    color: ${colorPallete.white};

                    & + .hq-banner-description p {
                        font-size: ${bodyFonts.body1RegularLg.fontSize};
                        line-height: ${bodyFonts.body1RegularLg.lineHeight};
                        font-weight: ${bodyFonts.body1RegularLg.fontWeight};
                        margin-bottom: 0;
                    }
                }

                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    css`
                        .hq-banner-title {
                            font-size: ${headlineFonts.headline2SemiBoldSm.fontSize};
                            line-height: ${headlineFonts.headline2SemiBoldSm.lineHeight};

                            & + .hq-banner-description {
                                margin-bottom: 24px;
                            }
                        }
                    `,
                    css`
                        padding: 40px;
                    `,
                    null,
                ], "max")}
            }
            /* Headquarter banner */

            /* Employee owned banner */
            .eo-banner-wrapper {
                background: ${colorPallete.secondaryNavy500};
                padding: 25px 58px;
                margin: 0 0 24px 0 !important;
                display: flex;
                align-items: center;
                justify-content: center;
                column-gap: 40px;
                border-radius: 8px;
                color: ${colorPallete.white};

                .eo-title, .eo-description {
                    flex-basis: 50%;
                    max-width: 50%;
                }

                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    css`
                        flex-direction: column;
                        padding: 24px;
                        align-items: flex-start;
                        max-width: calc(100% - 32px);
                        margin: 24px auto !important;

                        .eo-title, .eo-description {
                            flex-basis: 100%;
                            max-width: 100%;
                        }
                    `,
                    null,
                    null,
                ], "max")}

                .eo-title {
                    font-size: ${displayHeading.displaySemiboldSm.fontSize};
                    line-height: ${displayHeading.displaySemiboldSm.lineHeight};
                    font-weight: ${displayHeading.displaySemiboldSm.fontWeight};
                    color: ${colorPallete.white};
                    margin-bottom: 0;

                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        css`
                            font-size: ${headlineFonts.headline2SemiBoldSm.fontSize};
                            line-height: ${headlineFonts.headline2SemiBoldSm.lineHeight};
                            margin-bottom: 16px;
                        `,
                        null,
                        null,
                    ], "max")}
                }

                .eo-description p {
                    font-size: ${headlineFonts.headline4RegularLg.fontSize};
                    line-height: ${headlineFonts.headline4RegularLg.lineHeight};
                    font-weight: ${headlineFonts.headline4RegularLg.fontWeight};
                    margin-bottom: 0;

                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        css`
                            font-size: ${bodyFonts.body1RegularLg.fontSize};
                            line-height: ${bodyFonts.body1RegularLg.lineHeight};
                        `,
                        null,
                        null,
                    ], "max")}
                }
            }

            .eo-auth-banner-wrapper {
                background: ${colorPallete.secondaryNavy500};
                display: flex;
                margin: 24px 0 !important;
                column-gap: 38px;
                border-radius: 8px;
                color: ${colorPallete.white};

                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    css`
                        flex-direction: column;
                        padding: 24px;
                        align-items: flex-start;
                        row-gap: 24px;
                        max-width: calc(100% - 32px);
                        margin: 24px auto !important;
                    `,
                    null,
                    null,
                ], "max")}

                .eo-auth-image {
                    flex-shrink: 0;
                    img {
                        display: block;
                        max-width: 326px;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 8px;
                    }

                    [class*="LazyImageStyle"] {
                        display: block !important;
                        padding: 0 !important;
                    }
                }

                .eo-auth-content {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: center;
                    padding: 29px 80px 29px 0;

                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        css`
                            padding: 0;
                        `,
                        null,
                        null,
                    ], "max")}
                }

                .eo-auth-title {
                    font-size: ${headlineFonts.headline2SemiBoldLg.fontSize};
                    line-height: ${headlineFonts.headline2SemiBoldLg.lineHeight};
                    margin-bottom: 16px;
                    color: ${colorPallete.white};

                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        css`
                            font-size: ${headlineFonts.headline2SemiBoldSm.fontSize};
                            line-height: ${headlineFonts.headline2SemiBoldSm.lineHeight};
                        `,
                        null,
                        null,
                    ], "max")}
                }

                .eo-auth-description p {
                    font-size: ${headlineFonts.headline4RegularLg.fontSize};
                    line-height: ${headlineFonts.headline4RegularLg.lineHeight};
                    font-weight: ${headlineFonts.headline4RegularLg.fontWeight};
                    margin-bottom: 0;

                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        css`
                            font-size: ${bodyFonts.body1RegularLg.fontSize};
                            line-height: ${bodyFonts.body1RegularLg.lineHeight};
                        `,
                        null,
                        null,
                    ], "max")}
                }
            }
            /* Employee owned banner */

            /* Rewards panel */
            .rewards-panel-wrapper {
                display: flex;
                max-width: 1280px;
                margin: 24px auto !important;
                flex-wrap: nowrap;
                column-gap: 16px;

                .rewards-panel-image {
                    [class*="LazyImageStyle"] {
                        display: block !important;
                        padding: 0 !important;
                    }
                }

                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    css`
                        flex-direction: column;
                        row-gap: 16px;
                    `,
                    css`
                        padding: 0 16px;
                    `,
                    null,
                ], "max")}

                > div  {
                    flex-basis: 50%;
                    max-width: 50%;

                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        css`
                            flex-basis: 100%;
                            max-width: 100%;

                            span {
                                width: 100%;
                            }
                        `,
                        null,
                        null,
                    ], "max")}
                }

                img {
                    display: block;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 8px;

                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        css`
                            min-height: 280px;
                        `,
                        null,
                        null,
                    ], "max")}
                }

                .rewards-panel-content {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: center;
                    padding: 40px 80px;
                    background: ${colorPallete.secondaryLightblue500};
                    border-radius: 8px;

                    h2 {
                        margin-bottom: 16px;
                    }

                    .rewards-panel-description {
                        margin-bottom: 40px;
                    }

                    .rewards-panel-description p {
                        margin-bottom: 0;
                    }

                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        css`
                            .rewards-panel-title {
                                font-size: ${headlineFonts.headline2SemiBoldSm.fontSize};
                                line-height: ${headlineFonts.headline2SemiBoldSm.lineHeight};
                            }

                            .rewards-panel-description {
                                margin-bottom: 24px;
                            }
                        `,
                        css`
                            padding: 40px;
                        `,
                        null,
                    ], "max")}

                }

                &.rewards-panel-lg {
                    .btn.with-icon {
                        display: inline-flex;
                        align-items: center;
                        column-gap: 4px;

                        margin-bottom: 40px;

                        ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            null,
                            css`
                                margin-bottom: 24px;
                            `,
                            null,
                            null,
                        ], "max")}

                        &::after {
                            content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='24' viewBox='0 0 25 24' fill='none'%3E%3Cg%3E%3Cpath d='M19.5 19H5.5V5H12.5V3H5.5C4.39 3 3.5 3.9 3.5 5V19C3.5 20.1 4.39 21 5.5 21H19.5C20.6 21 21.5 20.1 21.5 19V12H19.5V19ZM14.5 3V5H18.09L8.26 14.83L9.67 16.24L19.5 6.41V10H21.5V3H14.5Z' fill='%23FFFFFF'/%3E%3C/g%3E%3C/svg%3E");
                            line-height: 12.8px;
                        }

                        span {
                            display: flex;
                        }
                    }
                }
            }
            /* Rewards panel */
            [data-test-selector="modal_ModalContent"] {
                .no-bold {
                    font-weight: ${themeFontWeights.regular};
                }
                .asterik {
                    display: none;
                }
                input[type="radio"] + label {
                    font-weight: ${themeFontWeights.regular};
                }
                input[type="radio"]:checked + label {
                    &:after {
                        bottom: 0;
                        top: 0;
                        margin: auto;
                    }
                }
                label {
                    font-size: ${bodyFonts.body2SemiBoldLg.fontSize};
                    line-height: ${bodyFonts.body2SemiBoldLg.lineHeight};
                }
                .errorOnFormField {
                    input[type="text"],
                    textarea {
                        border-color: ${colorPallete.semanticError} !important;
                    }
                }
            }
            .errorMessageWrapper {
                border-radius: 8px;
                border: 1px solid ${colorPallete.semanticError};
                background: ${colorPallete.white};
                padding: 16px 15px;
                color: ${colorPallete.semanticError};
                display: flex;
                column-gap: 16px;
                .errorMessageIcon {
                    width: 24px;
                }
                .errorMessageContent {
                    display: flex;
                    flex-direction: column;
                    row-gap: 16px;
                    font: ${bodyFonts.body2RegularSm.fontWeight} ${bodyFonts.body2RegularSm.fontSize}/${bodyFonts.body2RegularSm.lineHeight} ${bodyFonts.body2RegularSm.fontFamily};
                    .wishlist-restricted-line-message-text {
                        margin-bottom: 0;
                    }
                    [class*="StyledButton"],
                    button {
                        margin: 0;
                        span {
                            font-weight: ${themeFontWeights.semiBold};
                            display: flex;
                            align-items: center;
                            column-gap: 8px;
                            svg {
                                width: 20px;
                                height: 20px;
                            }
                        }
                    }
                }
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding: 16px 18px;
                        `,
                    ],
                    "max",
                )}
                @media print {
                    padding: 8px !important;
                    gap: 8px !important;
                    .errorMessageIcon {
                        width: 16px !important;
                        svg {
                            width: 16px;
                            height: 16px;
                        }
                    }
                    .errorMessageContent {
                        [class*="Typography"] {
                            font-size: ${printFonts.bodyRegularSm.fontSize};
                            line-height: ${printFonts.bodyRegularSm.lineHeight};
                        }
                    }
                }
            }
            .branchOpenCloseTag {
                display: flex;
                padding: 3px 7px;
                justify-content: center;
                align-items: center;
                border-radius: 4px;
                min-width: 44px;
            }
            .branchOpenTag {
                border: 1px solid ${colorPallete.saveSemanticGreen500};
                color: ${colorPallete.saveSemanticGreen500};
                background: rgba(204, 251, 231, 0.30);
                font: ${labelFonts.label2SemiBold.fontWeight} ${labelFonts.label2SemiBold.fontSize}/${labelFonts.label2SemiBold.lineHeight} ${labelFonts.label2SemiBold.fontFamily};
            }
            .branchCloseTag {
                border: 1px solid ${colorPallete.semanticError};
                background: rgba(255, 0, 20, 0.05);
                color: ${colorPallete.semanticError};
                font: ${labelFonts.label2Regular.fontWeight} ${labelFonts.label2Regular.fontSize}/${labelFonts.label2Regular.lineHeight} ${labelFonts.label2Regular.fontFamily};
            }
            .openNewWindowIcon {
                display: inline-flex;
                column-gap: 8px;
                align-items: center;
                &:after {
                    content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='24' viewBox='0 0 25 24' fill='none'%3E%3Cg%3E%3Cpath d='M19.5 19H5.5V5H12.5V3H5.5C4.39 3 3.5 3.9 3.5 5V19C3.5 20.1 4.39 21 5.5 21H19.5C20.6 21 21.5 20.1 21.5 19V12H19.5V19ZM14.5 3V5H18.09L8.26 14.83L9.67 16.24L19.5 6.41V10H21.5V3H14.5Z' fill='%23FFFFFF'/%3E%3C/g%3E%3C/svg%3E");
                    line-height: 0;
                }
            }
            .twoThirdColumnsLayout {
                > div {
                    row-gap: 24px;
                }
                .boxGreyAll24,
                .greyBoxWithBorder2416 {
                    display: flex;
                    flex-direction: column;
                }
            } 
            .twoColumnImageWithTextSection {
                display: flex;
                flex-direction: column;
                gap: 24px;
                .imageWrapper {
                    display: flex;
                }
                [class*="LazyImageStyle"] {
                    width: 100%;
                }
            }
            .twoEqualColumnsBanner {
                position: relative;
                display: flex;
                align-items: center;
                img {
                    border-radius: 8px;
                }
                [class*="LazyImageStyle"] {
                    width: 100%; 
                }
                .overlayWrapper {
                    max-width: 410px;
                    border-radius: 8px;
                    padding: 16px;
                    position: absolute;
                    left: 16px;
                    width: auto;
                    right: 16px;
                }
            }
            .branchComponent {
                margin-top: 24px;
            }
            .contactUsCTABanner {
                display: flex;
                > button,
                > a {
                    min-width: 234px;
                    max-width: 350px;
                    display: flex;
                    padding: 0;
                    border: none;
                    cursor: pointer;
                    &:focus {
                        outline-offset: 1px;
                    }
                    &:focus:not(:focus-visible) {
                        outline-offset: 0;
                    }
                }
                a {
                    > span {
                        display: flex;
                    }
                }
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            position: absolute;
                            top: auto;
                            bottom: 0;
                            transform: translate(24px, 50%);
                            &.rightAlign {
                                right: 24px;
                                transform: translate(0, 50%);
                                left: auto;
                            }
                        `
                    ],
                    "min",
                )}
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            min-width: 234px;
                            max-width: 350px;
                            display: inline-flex;
                            justify-content: center;
                            button,
                            a {
                                width: 100%;
                            }
                        `
                    ],
                    "max",
                )}
                a {
                    &[class*="StyledClickable"] {
                        padding: 0;
                        min-height: initial;
                        margin: 0 !important;
                        border-radius: 0;
                        text-align: left;
                        justify-content: flex-start;
                    }
                }
                .ctaIconWrapper {
                    width: 60px;
                    padding: 10px;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    img {
                        display: flex;
                        width: 40px;
                        max-width: 40px;
                        min-width: 40px;
                    }
                }
                .ctaTextWrapper {
                    padding: 6px 16px 6px 24px;
                    height: 100%;
                    text-align: left;
                    width: 100%;
                    font: ${bodyFonts.body2RegularLg.fontWeight} ${bodyFonts.body2RegularLg.fontSize}/${bodyFonts.body2RegularLg.lineHeight} ${bodyFonts.body2RegularLg.fontFamily};
                    strong {
                        font: ${bodyFonts.body1SemiBoldLg.fontWeight} ${bodyFonts.body1SemiBoldLg.fontSize}/${bodyFonts.body1SemiBoldLg.lineHeight} ${bodyFonts.body1SemiBoldLg.fontFamily};
                    }
                }
            }

            .previousPurchasedBadge {
                border-radius: 4px;
                background: ${colorPallete.statusTagBlue};
                padding: 4px 8px;
                min-height: 24px;
                font: italic ${labelFonts.label2SemiBold.fontWeight} ${labelFonts.label2SemiBold.fontSize}/${labelFonts.label2SemiBold.lineHeight} ${labelFonts.label2SemiBold.fontFamily};
                text-transform: uppercase;
                color: ${colorPallete.secondaryNavy500};
                display: inline-block;
                width: auto;
                @media print {
                    font-size: ${printFonts.bodyRegularSm.fontSize};
                    line-height: ${printFonts.bodyRegularSm.lineHeight};
                    padding: 0;
                    min-height: initial;
                    margin: 0;
                    background: ${colorPallete.white};
                }
            }

            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        .twoEqualColumnsBanner {
                            img {
                                min-height: initial !important;
                            }
                            h1 {
                                font-size: clamp(16px, calc(16px + (38 - 16) * (100vw - 768px)/(1440 - 768)), 38px) !important;
                                line-height:clamp(24px,calc(24px + (49 - 24) * (100vw - 768px)/(1440 - 768)),49px) !important;
                                margin-bottom: 8px !important;
                            }
                            p {
                                font-size: clamp(12px, calc(12px + (16 - 12) * (100vw - 768px)/(1440 - 768)), 16px) !important;
                                line-height: clamp(18px, calc(18px + (24 - 18) * (100vw - 768px)/(1440 - 768)), 24px) !important;
                            }
                        }
                        .twoThirdColumnsLayout {
                            > [class*="GridOffset"] {
                                column-gap: 40px;
                                flex-wrap: nowrap;
                            }
                            &:not(.withNormalHeight) {
                                > div > div {
                                    > div,
                                    > div > div,
                                    > div > div > div,
                                    > div > div > div > div {
                                        height: 100%;
                                    }
                                }
                            }
                            .boxGreyAll24,
                            .greyBoxWithBorder2416 {
                                align-items: self;
                                .buttonWrapper,
                                > [class*="StyledClickable"] {
                                    margin-top: auto;
                                }
                            }
                        }
                        .twoColumnImageWithTextSection {
                            flex-direction: row;
                            gap: 40px;
                            align-items: flex-start;
                            .imageWrapper {
                                max-width: 314px;
                                width: 100%;
                            }
                        }
                    `,
                    css`
                        .twoEqualColumnsBanner {
                            .overlayWrapper {
                                padding: 24px;
                            }
                        }
                    `
                ],
                "min",
            )}
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        .twoEqualColumnsBanner {
                            img {
                                min-height: initial !important;
                            }
                            p {
                                font-size: ${bodyFonts.body2RegularLg.fontSize};
                                line-height: ${bodyFonts.body2RegularLg.lineHeight};
                                margin-bottom: 16px;
                            }
                        }
                    `,
                    css`
                        .twoEqualColumnsBanner {
                            .dsgCMSBtn {
                                min-height: 38px;
                                padding: 4px 24px;
                                border-radius: 30px;
                                font: ${buttonFonts.buttonSm.fontWeight} ${buttonFonts.buttonSm.fontSize} /
                                    ${buttonFonts.buttonSm.lineHeight} ${buttonFonts.buttonSm.fontFamily};
                            }
                        }
                        #react-app {
                            > [data-test-selector="page_Page"] {
                                .organizationWrapper {
                                    margin-left: -16px;
                                    margin-right: -16px;
                                    width: calc(100% + 32px);
                                }
                                .donorComponentWrapper {
                                    margin-left: -16px;
                                    margin-right: -16px;
                                    width: calc(100% + 32px);
                                }
                                .fullWidthWrapper {
                                    margin-left: -16px !important;
                                    margin-right: -16px !important;
                                    width: calc(100% + 32px) !important;
                                    max-width: calc(100% + 32px) !important;
                                }
                            }
                        }
                    `,
                ],
                "max",
            )}

            @media screen and (min-width: 768px) and (max-width: 1300px) {
                [data-test-selector="homePage"] {
                    .branchComponent {
                        margin-left: -24px;
                        margin-right: -24px;
                        max-width: calc(100% + 48px) !important;
                        width: calc(100% + 48px);
                    }
                }
            }
          
            @media screen and (min-width: 1346px) {
                #react-app {
                    > [data-test-selector="page_Page"] {
                        .organizationWrapper {
                            margin: 24px -80px;
                        }
                        .donorComponentWrapper {
                            margin-left: -80px;
                            margin-right: -80px;
                        }
                        .fullWidthWrapper {
                            max-width: 1440px;
                            width: calc(100% + 160px);
                            margin-left: -80px !important;
                            margin-right: -80px !important;
                        }
                    }
                }
            }
            .printOnly {
                display: none !important;
            }
            @media print {
                .printHeader * {
                    font-size: ${printFonts.bodyRegularLg.fontSize};
                    font-weight: ${themeFontWeights.regular};
                    line-height: inherit;
                }
                .printOnly {
                    display: inherit !important;
                }
                .hideOnPrint {
                    display: none !important
                }
                .order-confirmation-page {
                    .invoice-information > div > div {
                        width: 100%;
                    }
                    [data-test-selector="orderConfirmationBillingInformation"] {
                        width: 100%;
                    }
                   
                }
                .product-expanded-grid-carousel.product-carousel {
                    display: none !important;
                }
            }
            [data-test-selector="page_VmiLocationDetailsPage"] {
                #tabListProducts > div > div{
                    position: relative;
                }
            }
            [data-test-selector="modal_ModalContent"] {
                label[for="vmiLocationUploadFileUpload"],
                label[for="vmiBinUploadFileUpload"] {
                    display: flex;
                    align-items: center;
                }
            }

            /*
                Coveo Global Changes
            */
            .backgroundSearchOverlay {
                display: none;
            }
            .searchSurveyWrapper {
                display: flex;
                justify-content: flex-end;
            }
                 
            #search-survey {
                a {
                    display: flex; 
                    height: 38px; 
                    padding: 4px 21px; 
                    justify-content: center;
                    align-items: center;
                    gap: 4px;
                    border-radius: 30px; 
                    color: ${colorPallete.secondaryNavy500};
                    border: 2px solid ${colorPallete.secondaryNavy500};
                    background: ${colorPallete.white};
                    font-size: ${bodyFonts.body2RegularLg.fontSize};
                    line-height: 130%;
                    font-weight: ${themeFontWeights.semiBold};
                    margin-bottom: 8px;
                    &:before {
                        content: '';
                        background-image: url('/userfiles/feedback-icon.png'); 
                        width: 24px; 
                        height: 24px; 
                        display: flex;
                    }
                }
            }   
                 
             
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    null,
                    css`
                        .overlayActive {
                            [class*="PageLayoutWrapper"] {
                                .backgroundSearchOverlay {
                                    display: block;
                                    &.hidden {
                                        display: none;
                                    }
                                }
                                .backgroundSearchOverlay:before{
                                    content: '';
                                    position: fixed;
                                    height: 100%;
                                    top: 0;
                                    left: 0;
                                    background: rgba(27, 28, 28, 0.60);
                                    z-index: 998;
                                    display: block;
                                    width: 100%;
                                }
                                .websiteHeader,
                                .vmiHeader,
                                .vmiSubHeader,
                                .subHeaderLoggedIn,
                                .shipAuthMsgWrapper {
                                    background: rgba(27, 28, 28, 0.60);
                                }
                                .external-wrapper,
                                .dsg-shipping-address {
                                    z-index: -1;
                                }
                                header {
                                    z-index: 999;
                                }
                            } 
                        }
                    `,
                ],
                "min",
            )}
            .clearIconButton {
                &,
                &:not(:disabled),
                &:hover,
                &:focus,
                &:active {
                    padding: 0;
                    min-height: initial;
                    border: none;
                    background: transparent;
                    position: absolute;
                    right: 72px;
                    top: 8px;
                  
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        css`
                            right: 48px;
                            top: 8px;
                            svg {
                                width: 24px;
                                height: 24px;
                            }
                        `,
                    ], "max")}
    
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        null,
                        css`
                            z-index: 999;
                        `,
                    ], "min")}
                }
            }
            
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        .searchSurveyWrapper {
                            margin: -18px 24px 0 0 !important;
                        }
                    `,
                ],
                "max",
            )}
            
            [data-test-selector="page_BrandDetailsPage"],
            [data-test-selector="page_ProductListPage"] {
                [class*="LoadingSpinnerStyle"] {
                   display: none;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        .searchWrapper * {
                            transition: none !important;
                        }            
                        #headerSearch-popover {
                            background: transparent;
                            box-shadow: none;
                        }
                    `,
                ],
                "max",
            )}
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    null,
                    css`
                        .searchWrapper {
                            .searchContent {
                                transition: min-height 0.01s ease-in-out !important; 
                            }
                        }
                    `,
                ],
                "min",
            )}
        `,
    },
});
